import { j as jsxRuntimeExports } from "./jsx-runtime-ClFauRgV.mjs";
import React__default$1, { Fragment } from "react";
import { useTheme, css } from "styled-components";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", {
    value: true
  });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var lodash_merge = { exports: {} };
lodash_merge.exports;
(function(module, exports$1) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var HOT_COUNT = 800, HOT_SPAN = 16;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports$1 && !exports$1.nodeType && exports$1;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function apply2(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString = objectProto2.toString;
  var objectCtorString = funcToString2.call(Object);
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array;
  Buffer ? Buffer.allocUnsafe : void 0;
  var getPrototype2 = overArg2(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var defineProperty = function() {
    try {
      var func = getNative2(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeMax2 = Math.max, nativeNow = Date.now;
  var Map2 = getNative2(root2, "Map"), nativeCreate2 = getNative2(Object, "create");
  var baseCreate = /* @__PURE__ */ function() {
    function object() {
    }
    return function(proto) {
      if (!isObject2(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = void 0;
      return result;
    };
  }();
  function Hash2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    var data = getMapData2(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function Stack(entries) {
    var data = this.__data__ = new ListCache2(entries);
    this.size = data.size;
  }
  function stackClear() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache2) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache2(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value, inherited) {
    var isArr = isArray2(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length = result.length;
    for (var key in value) {
      if (!(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq2(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty2.call(object, key) && eq2(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) {
      defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var baseFor = createBaseFor();
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString2(value);
  }
  function baseIsArguments(value) {
    return isObjectLike2(value) && baseGetTag(value) == argsTag2;
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  function baseKeysIn2(object) {
    if (!isObject2(object)) {
      return nativeKeysIn2(object);
    }
    var isProto = isPrototype2(object), result = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor(source, function(srcValue, key) {
      stack || (stack = new Stack());
      if (isObject2(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
        if (newValue === void 0) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn2);
  }
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
      var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray2(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject2(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments2(srcValue)) {
        newValue = objValue;
        if (isArguments2(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject2(objValue) || isFunction2(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }
  function baseRest2(func, start) {
    return setToString(overRest(func, start, identity), func + "");
  }
  var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant(string),
      "writable": true
    });
  };
  function cloneBuffer(buffer, isDeep) {
    {
      return buffer.slice();
    }
  }
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = cloneArrayBuffer(typedArray.buffer);
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }
  function createAssigner(assigner) {
    return baseRest2(function(object, sources) {
      var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard2 = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
      if (guard2 && isIterateeCall(sources[0], sources[1], guard2)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object, key) {
    var value = getValue2(object, key);
    return baseIsNative2(value) ? value : void 0;
  }
  function getRawTag(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype2(object) ? baseCreate(getPrototype2(object)) : {};
  }
  function isIndex2(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isIterateeCall(value, index, object) {
    if (!isObject2(object)) {
      return false;
    }
    var type = typeof index;
    if (type == "number" ? isArrayLike2(object) && isIndex2(index, object.length) : type == "string" && index in object) {
      return eq2(object[index], value);
    }
    return false;
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function nativeKeysIn2(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  function objectToString2(value) {
    return nativeObjectToString.call(value);
  }
  function overRest(func, start, transform) {
    start = nativeMax2(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index = -1, length = nativeMax2(args.length - start, 0), array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply2(func, this, otherArgs);
    };
  }
  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }
    if (key == "__proto__") {
      return;
    }
    return object[key];
  }
  var setToString = shortOut(baseSetToString);
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments2 = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject2(value) {
    return isObjectLike2(value) && isArrayLike2(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag || tag == proxyTag;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return value != null && typeof value == "object";
  }
  function isPlainObject(value) {
    if (!isObjectLike2(value) || baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = getPrototype2(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString;
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  function toPlainObject(value) {
    return copyObject(value, keysIn2(value));
  }
  function keysIn2(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeysIn2(object);
  }
  var merge2 = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  function constant(value) {
    return function() {
      return value;
    };
  }
  function identity(value) {
    return value;
  }
  function stubFalse() {
    return false;
  }
  module.exports = merge2;
})(lodash_merge, lodash_merge.exports);
var lodash_mergeExports = lodash_merge.exports;
var merge = /* @__PURE__ */ getDefaultExportFromCjs(lodash_mergeExports);
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _inheritsLoose$1(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper2(t2) {
    if (null === t2 || !_isNativeFunction(t2)) return t2;
    if ("function" != typeof t2) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t2)) return r.get(t2);
      r.set(t2, Wrapper);
    }
    function Wrapper() {
      return _construct(t2, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), _setPrototypeOf(Wrapper, t2);
  }, _wrapNativeSuper(t);
}
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
  "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
  "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
  "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
  "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
  "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
  "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function(d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
var PolishedError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose$1(PolishedError2, _Error);
  function PolishedError2(code) {
    var _this;
    if (process.env.NODE_ENV === "production") {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(color) {
  if (typeof color !== "string") return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color) {
  if (typeof color !== "string") {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(color) {
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    if (color.alpha !== void 0) {
      return {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== void 0) {
    return {
      hue,
      saturation,
      lightness,
      alpha: color.alpha
    };
  }
  return {
    hue,
    saturation,
    lightness
  };
}
function parseToHsl(color) {
  return rgbToHsl(parseToRgb(color));
}
var reduceHexValue = function reduceHexValue2(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
  if (typeof value === "object" && saturation === void 0 && lightness === void 0) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === "object" && saturation === void 0 && lightness === void 0 && alpha === void 0) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}
function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === "object" && green === void 0 && blue === void 0) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}
var isRgb = function isRgb2(color) {
  return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var isRgba = function isRgba2(color) {
  return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && typeof color.alpha === "number";
};
var isHsl = function isHsl2(color) {
  return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var isHsla = function isHsla2(color) {
  return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && typeof color.alpha === "number";
};
function toColorString(color) {
  if (typeof color !== "object") throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}
function curried(f, length, acc) {
  return function fn() {
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}
function curry(f) {
  return curried(f, f.length, []);
}
function adjustHue(degree, color) {
  if (color === "transparent") return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    hue: hslColor.hue + parseFloat(degree)
  }));
}
curry(adjustHue);
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function darken(amount, color) {
  if (color === "transparent") return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}
var curriedDarken = curry(darken);
var curriedDarken$1 = curriedDarken;
function desaturate(amount, color) {
  if (color === "transparent") return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
}
curry(desaturate);
function getLuminance(color) {
  if (color === "transparent") return 0;
  var rgbColor = parseToRgb(color);
  var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
function lighten(amount, color) {
  if (color === "transparent") return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}
curry(lighten);
function mix(weight, color, otherColor) {
  if (color === "transparent") return otherColor;
  if (otherColor === "transparent") return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);
  var color1 = _extends$1({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === "number" ? parsedColor1.alpha : 1
  });
  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends$1({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === "number" ? parsedColor2.alpha : 1
  });
  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
}
var curriedMix = curry(mix);
var mix$1 = curriedMix;
function opacify(amount, color) {
  if (color === "transparent") return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends$1({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });
  return rgba(colorWithAlpha);
}
curry(opacify);
var defaultReturnIfLightColor = "#000";
var defaultReturnIfDarkColor = "#fff";
function readableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
  if (returnIfLightColor === void 0) {
    returnIfLightColor = defaultReturnIfLightColor;
  }
  if (returnIfDarkColor === void 0) {
    returnIfDarkColor = defaultReturnIfDarkColor;
  }
  var isColorLight = getLuminance(color) > 0.179;
  var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
  {
    return preferredReturnColor;
  }
}
function saturate(amount, color) {
  if (color === "transparent") return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
}
curry(saturate);
function setHue(hue, color) {
  if (color === "transparent") return color;
  return toColorString(_extends$1({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
}
curry(setHue);
function setLightness(lightness, color) {
  if (color === "transparent") return color;
  return toColorString(_extends$1({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
}
curry(setLightness);
function setSaturation(saturation, color) {
  if (color === "transparent") return color;
  return toColorString(_extends$1({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
}
curry(setSaturation);
function shade(percentage, color) {
  if (color === "transparent") return color;
  return mix$1(parseFloat(percentage), "rgb(0, 0, 0)", color);
}
curry(shade);
function tint(percentage, color) {
  if (color === "transparent") return color;
  return mix$1(parseFloat(percentage), "rgb(255, 255, 255)", color);
}
curry(tint);
function transparentize(amount, color) {
  if (color === "transparent") return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends$1({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
}
var curriedTransparentize = curry(transparentize);
var curriedTransparentize$1 = curriedTransparentize;
const BASE_COLOR_SCALES = {
  neutral: {
    0: "#FFFFFF",
    50: "#FAFAFA",
    100: "#F8F8F8",
    200: "#F3F3F3",
    300: "#E8E8E8",
    400: "#D1D1D1",
    500: "#BBBBBB",
    600: "#9B9B9B",
    700: "#6E6E6E",
    800: "#464646",
    900: "#282624"
  },
  red: {
    50: "#FFEBEA",
    100: "#FFC6C3",
    150: "#EE0000",
    200: "#FFA29D",
    300: "#FF7E77",
    400: "#FF5A51",
    500: "#FF362B",
    600: "#DB1E14",
    700: "#B20B02",
    800: "#890700",
    900: "#600500"
  },
  green: {
    50: "#EDF8F4",
    100: "#D1E8DF",
    200: "#ADCFC2",
    300: "#5FAE91",
    400: "#169269",
    500: "#13805C",
    600: "#106A4C",
    700: "#0C543C",
    800: "#093D2C",
    900: "#06271C"
  },
  yellow: {
    50: "#FDF9F6",
    100: "#FFF9EE",
    150: "#FFF5E5",
    200: "#FFECC7",
    300: "#FFDEA0",
    400: "#FFC453",
    500: "#DDA63E",
    600: "#BB8A2C",
    700: "#996E1D",
    800: "#775411",
    900: "#553B09"
  },
  blue: {
    50: "#F5F7F7",
    100: "#E9F1F9",
    200: "#D5EBEF",
    300: "#B2E3EC",
    400: "#7DD9E8",
    500: "#39B2C6",
    600: "#238C9D",
    700: "#177482",
    800: "#0C5561",
    900: "#0B3541"
  }
};
const BASE_SHADOWS = {
  l1: {
    bright: "0px 0px 1px 0px rgba(0, 0, 0, 0.25)",
    dim: "0px 2px 2px 0px rgba(0, 0, 0, 0.1)"
  },
  l2: {
    bright: "0px 0px 2px 0px rgba(0, 0, 0, 0.2)",
    dim: "0px 3px 10px 0px rgba(0, 0, 0, 0.08)"
  },
  l3: {
    dim: "0px 2px 5px 0px rgba(0, 0, 0, 0.2)"
  },
  l4: {
    bright: "0px 0px 1px 0px rgba(0, 0, 0, 0.3)",
    dim: "0px 18px 28px 0px rgba(0, 0, 0, 0.2)"
  }
};
const BASE_BREAKPOINTS = {
  mobile: {
    max: "767px"
  },
  mobileLarge: {
    min: "560px",
    max: "767px"
  },
  tablet: {
    min: "768px",
    max: "1135px"
  },
  laptop: {
    min: "1136px",
    max: "1439px"
  },
  largeDesktop: {
    min: "1440px"
  },
  desktop: {
    min: "768px"
  }
};
const BORDER = {
  width: {
    1: "1px",
    2: "2px",
    4: "4px"
  },
  radius: {
    1: "1px",
    2: "2px",
    3: "3px",
    4: "4px",
    5: "5px",
    6: "6px"
  },
  colors: {
    gray: BASE_COLOR_SCALES.neutral["200"]
  }
};
const SPACING = {
  2: "2px",
  4: "4px",
  6: "6px",
  8: "8px",
  10: "10px",
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  20: "20px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px",
  40: "40px",
  44: "44px",
  48: "48px",
  52: "52px",
  56: "56px",
  60: "60px",
  64: "64px",
  96: "96px",
  112: "112px",
  136: "136px",
  144: "144px",
  160: "160px",
  176: "176px"
};
const BASE_FONTS = {
  // Each theme should specify this
  fontsToLoad: [],
  // TODO: kill this and just use a pxToRem() method instead
  sizes: {
    10: "0.625rem",
    12: "0.75rem",
    14: "0.875rem",
    16: "1rem",
    18: "1.125rem",
    20: "1.25rem",
    21: "1.3125rem",
    24: "1.5rem",
    28: "1.75rem",
    32: "2rem",
    40: "2.5rem",
    42: "2.625rem",
    48: "3rem",
    72: "4.5rem"
  },
  // TODO: This might have some value but I'm not sold on it
  weights: {
    hairline: "100",
    light: "300",
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800"
  },
  // TODO: This needs to die
  lineHeights: {
    xxs: "1rem",
    xs: "1.125rem",
    sm: "1.25rem",
    med: "1.375rem",
    base: "1.5rem",
    lg: "1.75rem",
    xlg: "1.875rem",
    "120%": "120%",
    "125%": "125%",
    "130%": "130%",
    "140%": "140%"
  },
  // TODO: This needs to die
  letterSpacing: {
    "12%": "0.12em",
    "-1.5%": "-0.015em",
    "-0.5%": "-0.005em",
    "-1%": "-0.01em"
  }
};
const BASE_LINK_COLORS = {
  onColor: {
    default: "#ffffff",
    hover: "#ffffffcc",
    pressed: "#ffffffe6"
  }
};
const BASE_TOKENS = {
  shadows: BASE_SHADOWS,
  breakpoints: BASE_BREAKPOINTS,
  borders: BORDER,
  spacing: SPACING,
  fonts: BASE_FONTS,
  linkColors: BASE_LINK_COLORS
};
const checkThemeContract = (theme) => theme;
var LARGE_ARRAY_SIZE = 200;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
var MAX_SAFE_INTEGER = 9007199254740991;
var argsTag = "[object Arguments]", funcTag$1 = "[object Function]", genTag$1 = "[object GeneratorFunction]", symbolTag$1 = "[object Symbol]";
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
var reIsUint = /^(?:0|[1-9]\d*)$/;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")();
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
function arrayMap(array, iteratee) {
  var index = -1, length = array ? array.length : 0, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function arrayPush(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length, index = fromIndex + -1;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
function baseIsNaN(value) {
  return value !== value;
}
function baseTimes(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
function cacheHas(cache, key) {
  return cache.has(key);
}
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
function isHostObject$1(value) {
  var result = false;
  if (value != null && typeof value.toString != "function") {
    try {
      result = !!(value + "");
    } catch (e) {
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var arrayProto$1 = Array.prototype, funcProto$1 = Function.prototype, objectProto$1 = Object.prototype;
var coreJsData$1 = root$1["__core-js_shared__"];
var maskSrcKey$1 = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
var objectToString$1 = objectProto$1.toString;
var reIsNative$1 = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
var Symbol$2 = root$1.Symbol, getPrototype = overArg(Object.getPrototypeOf, Object), propertyIsEnumerable = objectProto$1.propertyIsEnumerable, splice$1 = arrayProto$1.splice, spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : void 0;
var nativeGetSymbols = Object.getOwnPropertySymbols, nativeMax = Math.max;
var Map$2 = getNative$1(root$1, "Map"), nativeCreate$1 = getNative$1(Object, "create");
function Hash$1(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function hashClear$1() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
}
function hashDelete$1(key) {
  return this.has(key) && delete this.__data__[key];
}
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? void 0 : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : void 0;
}
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$1.call(data, key);
}
function hashSet$1(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
Hash$1.prototype.clear = hashClear$1;
Hash$1.prototype["delete"] = hashDelete$1;
Hash$1.prototype.get = hashGet$1;
Hash$1.prototype.has = hashHas$1;
Hash$1.prototype.set = hashSet$1;
function ListCache$1(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear$1() {
  this.__data__ = [];
}
function listCacheDelete$1(key) {
  var data = this.__data__, index = assocIndexOf$1(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  return true;
}
function listCacheGet$1(key) {
  var data = this.__data__, index = assocIndexOf$1(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
function listCacheSet$1(key, value) {
  var data = this.__data__, index = assocIndexOf$1(data, key);
  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
ListCache$1.prototype.clear = listCacheClear$1;
ListCache$1.prototype["delete"] = listCacheDelete$1;
ListCache$1.prototype.get = listCacheGet$1;
ListCache$1.prototype.has = listCacheHas$1;
ListCache$1.prototype.set = listCacheSet$1;
function MapCache$1(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear$1() {
  this.__data__ = {
    "hash": new Hash$1(),
    "map": new (Map$2 || ListCache$1)(),
    "string": new Hash$1()
  };
}
function mapCacheDelete$1(key) {
  return getMapData$1(this, key)["delete"](key);
}
function mapCacheGet$1(key) {
  return getMapData$1(this, key).get(key);
}
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
function mapCacheSet$1(key, value) {
  getMapData$1(this, key).set(key, value);
  return this;
}
MapCache$1.prototype.clear = mapCacheClear$1;
MapCache$1.prototype["delete"] = mapCacheDelete$1;
MapCache$1.prototype.get = mapCacheGet$1;
MapCache$1.prototype.has = mapCacheHas$1;
MapCache$1.prototype.set = mapCacheSet$1;
function SetCache(values) {
  var index = -1, length = values ? values.length : 0;
  this.__data__ = new MapCache$1();
  while (++index < length) {
    this.add(values[index]);
  }
}
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$1);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arrayLikeKeys(value, inherited) {
  var result = isArray$1(value) || isArguments(value) ? baseTimes(value.length, String) : [];
  var length = result.length, skipIndexes = !!length;
  for (var key in value) {
    if (!(skipIndexes && (key == "length" || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
function assocIndexOf$1(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
function baseDifference(array, values, iteratee, comparator) {
  var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
  if (!length) {
    return result;
  }
  if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
    while (++index < length) {
      var value = array[index], computed = value;
      value = value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed, comparator)) {
        result.push(value);
      }
    }
  return result;
}
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (predicate(value)) {
      {
        arrayPush(result, value);
      }
    } else {
      result[result.length] = value;
    }
  }
  return result;
}
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$1(value) || isHostObject$1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}
function basePickBy(object, props, predicate) {
  var index = -1, length = props.length, result = {};
  while (++index < length) {
    var key = props[index], value = object[key];
    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}
function baseRest(func, start) {
  start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
function getMapData$1(map, key) {
  var data = map.__data__;
  return isKeyable$1(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function getNative$1(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : void 0;
}
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
function isFlattenable(value) {
  return isArray$1(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function isMasked$1(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$1;
  return value === proto;
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
function toKey$1(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}
function isArguments(value) {
  return isArrayLikeObject(value) && hasOwnProperty$1.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString$1.call(value) == argsTag);
}
var isArray$1 = Array.isArray;
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
function isArrayLikeObject(value) {
  return isObjectLike$1(value) && isArrayLike(value);
}
function isFunction$1(value) {
  var tag = isObject$1(value) ? objectToString$1.call(value) : "";
  return tag == funcTag$1 || tag == genTag$1;
}
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike$1(value) {
  return !!value && typeof value == "object";
}
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1;
}
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
}
var omit = baseRest(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap(baseFlatten(props), toKey$1);
  return basePick(object, baseDifference(getAllKeysIn(object), props));
});
function stubArray() {
  return [];
}
var lodash_omit = omit;
var omit$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_omit);
var FUNC_ERROR_TEXT = "Expected a function";
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reEscapeChar = /\\(\\)?/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function isHostObject(value) {
  var result = false;
  if (value != null && typeof value.toString != "function") {
    try {
      result = !!(value + "");
    } catch (e) {
    }
  }
  return result;
}
var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
var funcToString = funcProto.toString;
var hasOwnProperty = objectProto.hasOwnProperty;
var objectToString = objectProto.toString;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
var Symbol$1 = root.Symbol, splice = arrayProto.splice;
var Map$1 = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function Hash(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? void 0 : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : void 0;
}
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
}
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function ListCache(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear() {
  this.__data__ = [];
}
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function MapCache(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear() {
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function mapCacheDelete(key) {
  return getMapData(this, key)["delete"](key);
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : void 0;
}
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var stringToPath = memoize(function(string) {
  string = toString(string);
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, string2) {
    result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
function memoize(func, resolver) {
  if (typeof func != "function" || resolver && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var isArray = Array.isArray;
function isFunction(value) {
  var tag = isObject(value) ? objectToString.call(value) : "";
  return tag == funcTag || tag == genTag;
}
function isObject(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function get(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
var lodash_get = get;
var get$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_get);
const BASE_STATIC_BUCKET_MAP = {
  production: "https://static.bestow.com",
  uat: "https://static.uat.bestow.com",
  qa: "https://static.qa.bestow.com",
  development: "https://static.qa.bestow.com",
  ephemeral: "https://static.qa.bestow.com"
};
const getStaticAssetUrl = (path, carrier) => ({
  development: `${BASE_STATIC_BUCKET_MAP.development}/assets/${carrier}${path}`,
  qa: `${BASE_STATIC_BUCKET_MAP.qa}/assets/${carrier}${path}`,
  uat: `${BASE_STATIC_BUCKET_MAP.uat}/assets/${carrier}${path}`,
  production: `${BASE_STATIC_BUCKET_MAP.production}/assets/${carrier}${path}`,
  ephemeral: `${BASE_STATIC_BUCKET_MAP.ephemeral}/assets/${carrier}${path}`
});
const checkButtonThemeFormat = (object, breakpoints) => object;
const extendsType = () => (obj) => obj;
const BASE_FOCUS = (tokens) => ({
  gap: "1px",
  width: "2px",
  borderRadius: "4px",
  color: tokens.colors.focus
});
const pxToRem = (pixels, remScale = 16) => `${Number(pixels.replace("px", "")) / remScale}rem`;
const buildTypographyVariants = ({
  headlineProps,
  headerProps,
  bodyProps,
  labelProps,
  signatureProps,
  numericTextProps,
  disclaimerProps,
  hyperlinkProps
}) => (tokens) => {
  var _a, _b, _c;
  return {
    ...extendsType()({
      base: {
        headlineProps,
        headerProps,
        bodyProps,
        labelProps,
        signatureProps,
        numericTextProps,
        hyperlinkProps,
        disclaimerProps
      },
      margin: "0",
      variants: {
        // Title text
        headlineLarge: {
          ...headlineProps,
          desktop: {
            fontSize: pxToRem("64px"),
            lineHeight: tokens.fonts.lineHeights["120%"],
            letterSpacing: "-1%"
          },
          tablet: {
            fontSize: pxToRem("56px"),
            letterSpacing: "-1%"
          },
          mobile: {
            fontSize: pxToRem("52px"),
            lineHeight: tokens.fonts.lineHeights["120%"],
            letterSpacing: "-1%"
          }
        },
        headlineMedium: {
          ...headlineProps,
          desktop: {
            fontSize: pxToRem("48px"),
            lineHeight: tokens.fonts.lineHeights["125%"],
            letterSpacing: tokens.fonts.letterSpacing["-1%"]
          },
          tablet: {
            fontSize: pxToRem("48px"),
            letterSpacing: "-1%"
          },
          mobile: {
            fontSize: pxToRem("44px"),
            lineHeight: tokens.fonts.lineHeights["125%"],
            letterSpacing: tokens.fonts.letterSpacing["-0.5%"]
          }
        },
        headlineSmall: {
          ...headlineProps,
          desktop: {
            fontSize: pxToRem("40px"),
            lineHeight: tokens.fonts.lineHeights["125%"],
            letterSpacing: tokens.fonts.letterSpacing["-1%"]
          },
          tablet: {
            fontSize: pxToRem("40px"),
            letterSpacing: "-1%"
          },
          mobile: {
            fontSize: pxToRem("36px"),
            lineHeight: tokens.fonts.lineHeights["125%"],
            letterSpacing: tokens.fonts.letterSpacing["-1%"]
          }
        },
        headlineXSmall: {
          ...headlineProps,
          desktop: {
            fontSize: pxToRem("32px"),
            lineHeight: tokens.fonts.lineHeights["125%"],
            letterSpacing: tokens.fonts.letterSpacing["-1%"]
          },
          tablet: {
            fontSize: pxToRem("32px"),
            letterSpacing: tokens.fonts.letterSpacing["-1%"]
          },
          mobile: {
            fontSize: pxToRem("28px"),
            lineHeight: tokens.fonts.lineHeights["125%"],
            letterSpacing: tokens.fonts.letterSpacing["-1%"]
          }
        },
        // Heading Text
        headerXLarge: {
          ...headerProps,
          desktop: {
            fontSize: pxToRem("32px"),
            lineHeight: tokens.fonts.lineHeights["120%"],
            letterSpacing: "-1.5%"
          },
          tablet: {
            fontSize: pxToRem("32px"),
            letterSpacing: "-1.5%"
          },
          mobile: {
            fontSize: pxToRem("22px"),
            lineHeight: tokens.fonts.lineHeights["120%"]
          }
        },
        headerLarge: {
          ...headerProps,
          desktop: {
            fontSize: pxToRem("24px"),
            lineHeight: tokens.fonts.lineHeights["120%"]
          },
          tablet: {
            fontSize: pxToRem("24px"),
            letterSpacing: "-0.5%"
          },
          mobile: {
            fontSize: pxToRem("21px"),
            lineHeight: tokens.fonts.lineHeights["125%"]
          }
        },
        headerMedium: {
          ...headerProps,
          desktop: {
            fontSize: pxToRem("20px"),
            lineHeight: tokens.fonts.lineHeights["130%"]
          },
          tablet: {
            fontSize: pxToRem("20px")
          },
          mobile: {
            fontSize: pxToRem("18px"),
            lineHeight: tokens.fonts.lineHeights["125%"]
          }
        },
        headerSmall: {
          ...headerProps,
          desktop: {
            fontSize: pxToRem("16px"),
            lineHeight: tokens.fonts.lineHeights["140%"]
          },
          tablet: {
            fontSize: pxToRem("16px")
          },
          mobile: {
            fontSize: pxToRem("16px"),
            lineHeight: tokens.fonts.lineHeights["140%"]
          }
        },
        headerXSmall: {
          ...headerProps,
          desktop: {
            fontSize: pxToRem("14px"),
            lineHeight: tokens.fonts.lineHeights["140%"]
          },
          tablet: {
            fontSize: pxToRem("14px")
          },
          mobile: {
            fontSize: pxToRem("14px"),
            lineHeight: tokens.fonts.lineHeights["140%"]
          }
        },
        // Body Text
        bodyXLarge: {
          ...bodyProps,
          desktop: {
            fontSize: pxToRem("24px")
          },
          tablet: {
            fontSize: pxToRem("24px")
          },
          mobile: {
            fontSize: pxToRem("21px")
          }
        },
        bodyLarge: {
          ...bodyProps,
          desktop: {
            fontSize: pxToRem("20px")
          },
          tablet: {
            fontSize: pxToRem("20px")
          },
          mobile: {
            fontSize: pxToRem("18px")
          }
        },
        bodyMedium: {
          ...bodyProps,
          desktop: {
            fontSize: pxToRem("16px")
          },
          tablet: {
            fontSize: pxToRem("16px")
          },
          mobile: {
            fontSize: pxToRem("16px")
          }
        },
        bodySmall: {
          ...bodyProps,
          desktop: {
            fontSize: pxToRem("14px")
          },
          tablet: {
            fontSize: pxToRem("14px")
          },
          mobile: {
            fontSize: pxToRem("14px")
          }
        },
        bodyXSmall: {
          ...bodyProps,
          desktop: {
            fontSize: pxToRem("12px")
          },
          tablet: {
            fontSize: pxToRem("12px")
          },
          mobile: {
            fontSize: pxToRem("12px")
          }
        },
        // Labels
        labelLarge: {
          ...labelProps,
          desktop: {
            fontSize: pxToRem("18px")
          },
          tablet: {
            fontSize: pxToRem("18px")
          },
          mobile: {
            fontSize: pxToRem("16px")
          }
        },
        labelMedium: {
          ...labelProps,
          desktop: {
            fontSize: pxToRem("16px")
          },
          tablet: {
            fontSize: pxToRem("16px")
          },
          mobile: {
            fontSize: pxToRem("14px")
          }
        },
        labelSmall: {
          ...labelProps,
          desktop: {
            fontSize: pxToRem("14px")
          },
          tablet: {
            fontSize: pxToRem("14px")
          },
          mobile: {
            fontSize: pxToRem("12px")
          }
        },
        labelXSmall: {
          ...labelProps,
          desktop: {
            fontSize: pxToRem("12px")
          },
          tablet: {
            fontSize: pxToRem("12px")
          },
          mobile: {
            fontSize: pxToRem("10px")
          }
        },
        // Hyperlinks
        hyperlinkLarge: {
          lineHeight: "150%",
          ...hyperlinkProps,
          desktop: {
            fontSize: pxToRem("20px")
          },
          tablet: {
            fontSize: pxToRem("20px")
          },
          mobile: {
            fontSize: pxToRem("18px")
          }
        },
        hyperlinkMedium: {
          lineHeight: "140%",
          ...hyperlinkProps,
          desktop: {
            fontSize: pxToRem("16px")
          },
          tablet: {
            fontSize: pxToRem("16px")
          },
          mobile: {
            fontSize: pxToRem("16px")
          }
        },
        hyperlinkSmall: {
          lineHeight: "140%",
          ...hyperlinkProps,
          desktop: {
            fontSize: pxToRem("14px")
          },
          tablet: {
            fontSize: pxToRem("14px")
          },
          mobile: {
            fontSize: pxToRem("14px")
          }
        },
        hyperlinkXSmall: {
          lineHeight: "140%",
          ...hyperlinkProps,
          desktop: {
            fontSize: pxToRem("12px")
          },
          tablet: {
            fontSize: pxToRem("12px")
          },
          mobile: {
            fontSize: pxToRem("12px")
          }
        },
        // Disclaimers
        disclaimerMedium: {
          ...disclaimerProps,
          lineHeight: "150%",
          desktop: {
            fontSize: pxToRem("16px")
          },
          tablet: {
            fontSize: pxToRem("14px")
          },
          mobile: {
            fontSize: pxToRem("14px")
          }
        },
        disclaimerSmall: {
          lineHeight: "160%",
          ...disclaimerProps,
          desktop: {
            fontSize: pxToRem("14px")
          },
          tablet: {
            fontSize: pxToRem("11px")
          },
          mobile: {
            fontSize: pxToRem("11px")
          }
        },
        disclaimerXSmall: {
          lineHeight: "140%",
          ...disclaimerProps,
          desktop: {
            fontSize: pxToRem("12px")
          },
          tablet: {
            fontSize: pxToRem("10px")
          },
          mobile: {
            fontSize: pxToRem("10px")
          }
        },
        // Signature text
        signature: {
          desktop: {
            fontSize: pxToRem("24px"),
            fontFamily: signatureProps.fontFamily,
            lineHeight: "67%",
            ...(_a = signatureProps == null ? void 0 : signatureProps.variants) == null ? void 0 : _a.desktop
          },
          tablet: {
            fontSize: pxToRem("24px"),
            fontFamily: signatureProps.fontFamily,
            lineHeight: "67%",
            ...(_b = signatureProps == null ? void 0 : signatureProps.variants) == null ? void 0 : _b.tablet
          },
          mobile: {
            fontSize: pxToRem("21px"),
            fontFamily: signatureProps.fontFamily,
            lineHeight: "67%",
            ...(_c = signatureProps == null ? void 0 : signatureProps.variants) == null ? void 0 : _c.mobile
          }
        }
      }
    })
  };
};
const spacingKeys = ["m", "mt", "mr", "mb", "ml", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingLeft", "paddingRight", "paddingBottom"];
const typographyVariant = (variantName, typography) => {
  const baseTypographyStyles = omit$1(typography, "variants");
  const baseVariantName = variantName.replace(/\.mobile|\.desktop/, "");
  const baseVariantStyles = omit$1(get$1(typography, `variants.${baseVariantName}`), ["desktop", "mobile"]);
  const breakpointSpecificStyles = get$1(typography, `variants.${variantName}`);
  return omit$1(
    {
      ...baseTypographyStyles,
      ...baseVariantStyles,
      ...breakpointSpecificStyles
    },
    // Need to omit spacing styles since we don't want to pull those into components
    [...spacingKeys, "defaultVariant"]
  );
};
const BADGES = (tokens) => {
  const {
    colors
  } = tokens;
  const statusColors = colors.status;
  return extendsType()({
    display: "inline-flex",
    justifyContent: "center",
    width: "min-content",
    verticalAlign: "middle",
    fontWeight: "400",
    fontSize: "0.875rem",
    borderWidth: "1px",
    borderStyle: "solid",
    padding: "3px 12px",
    color: colors.text.default,
    defaultSize: "default",
    sizes: {
      default: {},
      compact: {},
      subcompact: {}
    },
    variants: {
      informationalWeak: {
        borderColor: colors.background.informative.light,
        backgroundColor: colors.background.informative.light
      },
      informationalModerate: {
        borderColor: colors.background.informative.default,
        backgroundColor: colors.background.informative.light
      },
      informationalStrong: {
        borderColor: colors.background.informative.default,
        backgroundColor: colors.background.informative.default,
        color: colors.text.onColor,
        fill: colors.text.onColor
      },
      successWeak: {
        borderColor: statusColors.success.light,
        backgroundColor: statusColors.success.light
      },
      successModerate: {
        borderColor: statusColors.success.default,
        backgroundColor: statusColors.success.light
      },
      successStrong: {
        borderColor: statusColors.success.default,
        backgroundColor: statusColors.success.default,
        color: colors.text.onColor
      },
      warningWeak: {
        borderColor: statusColors.warning.light,
        backgroundColor: statusColors.warning.light
      },
      warningModerate: {
        borderColor: statusColors.warning.default,
        backgroundColor: statusColors.warning.light
      },
      warningStrong: {
        borderColor: statusColors.warning.default,
        backgroundColor: statusColors.warning.default
      },
      errorWeak: {
        borderColor: statusColors.critical.light,
        backgroundColor: statusColors.critical.light
      },
      errorModerate: {
        borderColor: statusColors.critical.default,
        backgroundColor: statusColors.critical.light
      },
      errorStrong: {
        borderColor: statusColors.critical.default,
        backgroundColor: statusColors.critical.default,
        color: colors.text.onColor
      },
      neutralWeak: {
        borderColor: tokens.colors.background.default,
        backgroundColor: tokens.colors.background.default
      },
      neutralModerate: {
        borderColor: tokens.colors.border.default,
        backgroundColor: tokens.colors.background.default
      },
      neutralStrong: {
        borderColor: tokens.colors.background.surface100,
        backgroundColor: tokens.colors.background.surface100
      },
      neutralSubduedWeak: {
        borderColor: tokens.colors.background.surface200,
        backgroundColor: tokens.colors.background.surface200
      },
      neutralSubduedModerate: {
        borderColor: tokens.colors.border.default,
        backgroundColor: tokens.colors.background.surface100
      },
      neutralSubduedStrong: {
        borderColor: tokens.colors.neutral["300"],
        backgroundColor: tokens.colors.neutral["300"]
      }
    }
  });
};
const BUTTONS = (tokens, typography) => {
  const buttonColors = tokens.colors.buttons;
  return checkButtonThemeFormat({
    ...typographyVariant("headerSmall.mobile", typography),
    borderRadius: "6px",
    borderWidth: "2px",
    borderStyle: "solid",
    transition: "background 150ms ease-in-out",
    variants: {
      primary: {
        // base
        borderColor: "transparent",
        color: buttonColors.primary.text.default,
        fill: buttonColors.primary.text.default,
        bg: buttonColors.primary.fill.default,
        // hover
        hoverStyle: {
          bg: buttonColors.primary.fill.hover
        },
        // active
        activeStyle: {
          bg: buttonColors.primary.fill.pressed
        },
        disabledStyle: {
          bg: buttonColors.primary.fill.disabled,
          color: buttonColors.primary.text.disabled,
          fill: buttonColors.primary.text.disabled,
          boxShadow: "none"
        },
        focusRingStyle: BASE_FOCUS(tokens)
      },
      outline: {
        // base
        borderColor: buttonColors.secondary.border.default,
        color: buttonColors.secondary.text.default,
        fill: buttonColors.secondary.text.default,
        bg: buttonColors.secondary.fill.default,
        // hover
        hoverStyle: {
          borderColor: buttonColors.secondary.border.hover,
          bg: buttonColors.secondary.fill.hover
        },
        // active
        activeStyle: {
          bg: buttonColors.secondary.fill.pressed
        },
        disabledStyle: {
          borderColor: buttonColors.secondary.border.disabled,
          color: buttonColors.secondary.text.disabled,
          fill: buttonColors.secondary.text.disabled,
          bg: buttonColors.secondary.fill.disabled
        },
        focusRingStyle: BASE_FOCUS(tokens)
      },
      destructivePrimary: {
        // base
        borderColor: "transparent",
        color: tokens.colors.buttons.destructive.primary.text.default,
        fill: tokens.colors.buttons.destructive.primary.text.default,
        bg: tokens.colors.buttons.destructive.primary.fill.default,
        // hover
        hoverStyle: {
          bg: tokens.colors.buttons.destructive.primary.fill.hover
        },
        // active
        activeStyle: {
          bg: tokens.colors.buttons.destructive.primary.fill.pressed
        },
        disabledStyle: {
          bg: tokens.colors.buttons.destructive.primary.fill.disabled,
          borderColor: tokens.colors.buttons.destructive.primary.fill.disabled,
          color: tokens.colors.buttons.destructive.primary.text.disabled,
          fill: tokens.colors.buttons.destructive.primary.text.disabled,
          boxShadow: "none"
        },
        focusRingStyle: {
          ...BASE_FOCUS(tokens),
          color: tokens.colors.buttons.destructive.focus
        }
      },
      destructiveSecondary: {
        // base
        borderColor: tokens.colors.buttons.destructive.secondary.border.default,
        color: tokens.colors.buttons.destructive.secondary.text.default,
        fill: tokens.colors.buttons.destructive.secondary.text.default,
        backgroundColor: tokens.colors.buttons.destructive.secondary.fill.default,
        // hover
        hoverStyle: {
          bg: tokens.colors.buttons.destructive.secondary.fill.hover
        },
        // active
        activeStyle: {
          bg: tokens.colors.buttons.destructive.secondary.fill.pressed
        },
        disabledStyle: {
          color: tokens.colors.buttons.destructive.secondary.text.disabled,
          borderColor: tokens.colors.buttons.destructive.secondary.border.disabled,
          fill: tokens.colors.buttons.destructive.secondary.text.disabled,
          bg: tokens.colors.buttons.destructive.secondary.fill.disabled
        },
        focusRingStyle: {
          ...BASE_FOCUS(tokens),
          color: tokens.colors.buttons.destructive.focus
        }
      },
      ghost: {
        // base
        borderColor: "transparent",
        color: tokens.colors.buttons.ghost.text.default,
        fill: tokens.colors.buttons.ghost.text.default,
        bg: tokens.colors.buttons.ghost.fill.default,
        // hover
        hoverStyle: {
          bg: tokens.colors.buttons.ghost.fill.hover
        },
        // active
        activeStyle: {
          bg: tokens.colors.buttons.ghost.fill.pressed
        },
        disabledStyle: {
          bg: tokens.colors.buttons.ghost.fill.disabled,
          color: tokens.colors.buttons.ghost.text.disabled,
          fill: tokens.colors.buttons.ghost.text.disabled,
          boxShadow: "none"
        },
        focusRingStyle: BASE_FOCUS(tokens)
      },
      destructiveGhost: {
        // base
        borderColor: "transparent",
        color: tokens.colors.buttons.destructive.ghost.text.default,
        fill: tokens.colors.buttons.destructive.ghost.text.default,
        bg: tokens.colors.buttons.destructive.ghost.fill.default,
        // hover
        hoverStyle: {
          bg: tokens.colors.buttons.destructive.ghost.fill.hover
        },
        // active
        activeStyle: {
          bg: tokens.colors.buttons.destructive.ghost.fill.pressed
        },
        disabledStyle: {
          bg: tokens.colors.buttons.destructive.ghost.fill.disabled,
          borderColor: tokens.colors.buttons.destructive.ghost.fill.disabled,
          color: tokens.colors.buttons.destructive.ghost.text.disabled,
          boxShadow: "none",
          fill: tokens.colors.buttons.destructive.ghost.text.disabled
        },
        focusRingStyle: {
          ...BASE_FOCUS(tokens),
          color: tokens.colors.buttons.destructive.focus
        }
      }
    },
    sizes: {
      large: {
        padding: "10px 32px",
        iconSpacing: "8px"
      },
      medium: {
        fontSize: "0.875rem",
        padding: "7px 16px",
        iconSpacing: "8px"
      },
      small: {
        fontSize: "0.875rem",
        padding: "3px 12px",
        iconSpacing: "4px"
      }
    }
  }, tokens.breakpoints);
};
const BESTOW_LINKS = (tokens, typography) => {
  const linkColors = tokens.colors.links;
  return {
    // Typography styles
    ...typographyVariant("headerSmall.mobile", typography),
    focusRingStyle: BASE_FOCUS(tokens),
    defaultVariant: "default",
    defaultSize: "large",
    variants: {
      default: {
        color: linkColors.action.default,
        fill: linkColors.action.default,
        hoverStyle: {
          color: linkColors.action.hover,
          fill: linkColors.action.hover
        },
        activeStyle: {
          color: linkColors.action.pressed,
          fill: linkColors.action.pressed
        },
        disabledStyle: {
          color: linkColors.disabled,
          fill: linkColors.disabled
        }
      },
      onColor: {
        color: linkColors.onColor.default,
        fill: linkColors.onColor.default,
        hoverStyle: {
          color: linkColors.onColor.hover,
          fill: linkColors.onColor.hover
        },
        activeStyle: {
          color: linkColors.onColor.pressed,
          fill: linkColors.onColor.pressed
        },
        disabledStyle: {
          color: linkColors.disabled,
          fill: linkColors.disabled
        }
      },
      destructive: {
        color: linkColors.destructive.default,
        fill: linkColors.destructive.default,
        hoverStyle: {
          color: linkColors.destructive.hover,
          fill: linkColors.destructive.hover
        },
        activeStyle: {
          color: linkColors.destructive.pressed,
          fill: linkColors.destructive.pressed
        },
        disabledStyle: {
          color: linkColors.disabled,
          fill: linkColors.disabled
        }
      }
    },
    sizes: {
      large: {
        fontWeight: "500",
        fontSize: pxToRem("16px")
      },
      // NOTE: Medium/Small are the same but this is just the way it is in Figma. Designers have mentioned wanting to rework it at some point
      medium: {
        fontWeight: "500",
        fontSize: pxToRem("14px")
      },
      small: {
        fontWeight: "500",
        fontSize: pxToRem("14px")
      },
      xsmall: {
        fontWeight: "500",
        fontSize: pxToRem("12px")
      }
    }
  };
};
const BUTTON_GROUP = (tokens, typography) => ({
  borderStyle: "solid",
  borderWidth: tokens.borders.width["1"],
  borderColor: tokens.colors.forms.border.default,
  bg: tokens.colors.forms.fill.default,
  color: tokens.colors.forms.text.default,
  borderRadius: "6px",
  ...typographyVariant("bodyMedium.mobile", typography),
  lineHeight: tokens.fonts.lineHeights.xs,
  hoverStyle: {
    bg: tokens.colors.forms.fill.hover,
    borderColor: tokens.colors.forms.border.hover,
    borderStyle: "solid",
    borderWidth: tokens.borders.width["1"]
  },
  invalidStyle: {
    borderColor: tokens.colors.status.critical.default
  },
  unselectedStyle: {
    bg: tokens.colors.forms.fill.default
  },
  activeStyle: {
    bg: tokens.colors.forms.fill.pressed,
    borderColor: tokens.colors.forms.border.hover
  },
  disabledStyle: {
    bg: tokens.colors.forms.fill.disabled,
    color: tokens.colors.forms.text.disabled
  },
  selectedDisabledStyle: {
    bg: curriedDarken$1(0.15, tokens.colors.forms.fill.disabled),
    color: tokens.colors.forms.text.default,
    // Use same font weight as selected variant for consistency across themes
    fontWeight: tokens.fonts.weights.medium,
    borderColor: tokens.colors.links.disabled
  },
  focusRingStyle: BASE_FOCUS(tokens),
  verticalStyle: {
    px: tokens.spacing["24"],
    startPadding: void 0,
    endPadding: void 0
  },
  variants: {
    selected: {
      fontWeight: tokens.fonts.weights.medium,
      bg: tokens.colors.forms.fill.selected,
      color: readableColor(tokens.colors.forms.fill.selected, tokens.colors.forms.text.default, tokens.colors.text.onColor),
      borderColor: tokens.colors.forms.border.selected,
      borderStyle: "solid",
      borderWidth: tokens.borders.width["1"],
      hoverStyle: {
        bg: tokens.colors.forms.fill.selectedHover,
        borderColor: tokens.colors.forms.border.selected,
        borderStyle: "solid",
        borderWidth: tokens.borders.width["1"]
      },
      activeStyle: {
        bg: tokens.colors.forms.fill.selectedHover,
        borderColor: tokens.colors.forms.border.selected,
        borderStyle: "solid",
        borderWidth: tokens.borders.width["1"]
      }
    }
  },
  defaultSize: "large",
  sizes: {
    small: {
      px: "12px",
      paddingBottom: "5px",
      paddingTop: "7px"
    },
    medium: {
      px: "16px",
      paddingBottom: "9px",
      paddingTop: "11px"
    },
    large: {
      px: "24px",
      paddingBottom: "12px",
      paddingTop: "14px"
    }
  }
});
const DIVIDERS = (tokens) => ({
  defaultVariant: "default",
  variants: {
    default: {
      bg: tokens.colors.border.default
    },
    onColor: {
      bg: tokens.colors.border.onColor,
      opacity: "0.2"
    },
    accent: {
      background: tokens.colors.background.accentConsumer
    }
  }
});
const BULLET_INPUTS = (tokens, typography) => ({
  borderWidth: tokens.borders.width["1"],
  checkbox: {
    borderRadius: tokens.borders.radius["3"]
  },
  bulletPadding: "8px",
  bulletSize: "20px",
  fill: tokens.colors.forms.text.default,
  ...typographyVariant("bodySmall.mobile", typography),
  lineHeight: tokens.fonts.lineHeights.med,
  focusStyle: {
    boxShadow: `0 0 0 2px white, 0 0 0 4px ${BASE_FOCUS(tokens).color}`
  },
  variants: {
    unchecked: {
      background: tokens.colors.forms.fill.default,
      borderColor: tokens.colors.forms.border.default,
      hoverStyle: {
        background: tokens.colors.forms.fill.hover,
        borderColor: tokens.colors.forms.border.hover
      }
    },
    checked: {
      background: tokens.colors.forms.fill.selected,
      borderColor: tokens.colors.forms.border.selected,
      fill: readableColor(tokens.colors.forms.fill.selected, tokens.colors.forms.text.default, tokens.colors.text.onColor),
      hoverStyle: {
        background: tokens.colors.forms.fill.selectedHover,
        borderColor: tokens.colors.forms.border.selected
      }
    },
    invalid: {
      background: tokens.colors.forms.fill.default,
      borderColor: tokens.colors.status.critical.default,
      hoverStyle: {
        background: tokens.colors.forms.fill.hover
      }
    },
    invalidChecked: {
      fill: tokens.colors.text.onColor,
      background: tokens.colors.status.critical.default,
      borderColor: tokens.colors.status.critical.default
    },
    disabled: {
      background: tokens.colors.forms.fill.disabled,
      borderColor: tokens.colors.forms.border.default
    },
    disabledChecked: {
      background: tokens.colors.forms.fill.disabled,
      borderColor: tokens.colors.forms.border.default,
      fill: tokens.colors.iconInteraction.disabled
    }
  }
});
const RADIO_CONTAINED_INPUTS = (tokens, typography) => ({
  background: tokens.colors.background.default,
  border: `2px solid transparent`,
  borderRadius: tokens.borders.radius["6"],
  boxShadow: `0 0 0 1px ${tokens.colors.forms.border.default}`,
  display: "flex",
  flexDirection: "column",
  padding: "12px 16px",
  width: "100%",
  labelStyles: {
    ...typographyVariant("headerSmall.desktop", typography)
  },
  hoverStyle: {
    background: tokens.colors.forms.fill.hover,
    boxShadow: `0 0 0 1px ${tokens.colors.forms.border.hover}`
  },
  focusStyle: {
    boxShadow: `0 0 0 1px ${tokens.colors.forms.border.default}`,
    outline: `2px solid ${tokens.colors.forms.border.selected}`,
    outlineOffset: "2px"
  },
  variants: {
    unchecked: {
      border: "2px solid transparent"
    },
    checked: {
      border: `2px solid ${tokens.colors.forms.border.selected}`,
      boxShadow: "none",
      hoverStyle: {
        background: tokens.colors.forms.fill.hover,
        boxShadow: "none"
      }
    },
    invalid: {
      borderColor: tokens.colors.status.critical.default
    },
    invalidChecked: {
      borderColor: tokens.colors.status.critical.default
    },
    disabled: {
      background: tokens.colors.forms.fill.disabled,
      hoverStyle: {
        background: tokens.colors.forms.fill.disabled,
        boxShadow: `0 0 0 1px ${tokens.colors.forms.border.default}`
      }
    },
    disabledChecked: {
      background: tokens.colors.forms.fill.disabled,
      hoverStyle: {
        background: tokens.colors.forms.fill.disabled,
        boxShadow: `0 0 0 1px ${tokens.colors.forms.border.default}`
      }
    }
  }
});
const INPUTS = (tokens, typography) => ({
  height: "48px",
  // default height/width, but will likely be overridden a lot to fit different containers
  margin: `${tokens.spacing["16"]}`,
  marginBottom: "12px",
  marginTop: "14px",
  // TODO set to 12 if Rotunda spacing is normalized
  borderWidth: "1px",
  borderColor: tokens.colors.forms.border.default,
  borderRadius: "4px",
  caretColor: tokens.colors.focus,
  color: tokens.colors.forms.text.default,
  bg: tokens.colors.forms.fill.default,
  iconSpacingToEdge: tokens.spacing["14"],
  iconSpacingToContent: tokens.spacing["10"],
  // Typography styles
  ...typographyVariant("headerSmall.desktop", typography),
  fontWeight: tokens.fonts.weights.light,
  hoverStyle: {
    outlineWidth: "1px",
    outline: "none",
    boxShadow: `0 0 0 1px ${tokens.colors.forms.border.hover}`,
    borderColor: tokens.colors.forms.border.hover
  },
  focusStyle: {
    boxShadow: `0 0 0 1px ${tokens.colors.focus}`,
    borderColor: tokens.colors.focus,
    outlineColor: BASE_FOCUS(tokens).color
  },
  invalidStyle: {
    boxShadow: `0 0 0 1px ${tokens.colors.status.critical.default}`,
    borderColor: tokens.colors.status.critical.default,
    outlineColor: tokens.colors.status.critical.default
  },
  disabledStyle: {
    backgroundColor: tokens.colors.forms.fill.disabled,
    // This is the same as the base, but it needs to be explicit so that it takes priority over hover styles
    borderColor: tokens.colors.forms.border.default,
    borderWidth: tokens.borders.width["1"],
    fontWeight: tokens.fonts.weights.normal,
    boxShadow: "none",
    color: tokens.colors.forms.text.disabled,
    labelStyles: {
      color: tokens.colors.forms.text.disabled
    }
  },
  // For the Caret Down Icon within Selects
  selectIconColor: tokens.colors.forms.text.default,
  labelStyles: {
    ...typographyVariant("bodyMedium.desktop", typography),
    color: tokens.colors.text.subdued,
    fontWeight: tokens.fonts.weights.light,
    disabledColor: tokens.colors.forms.text.disabled
  },
  placeholderStyles: {
    ...typographyVariant("bodyMedium.desktop", typography),
    color: `${tokens.colors.text.subdued} !important`
  },
  assistiveTextStyles: {
    marginTop: tokens.spacing["4"],
    ...typographyVariant("bodyXSmall.desktop", typography),
    color: tokens.colors.text.default,
    invalidStyle: {
      color: tokens.colors.status.critical.default
    }
  },
  maskStyles: {
    color: tokens.colors.forms.text.hint
  },
  // Bullet inputs = Checkbox/Radio inputs
  bullets: BULLET_INPUTS(tokens, typography),
  radioContained: RADIO_CONTAINED_INPUTS(tokens, typography),
  variants: {
    numeric: {
      fontFamily: typography.base.numericTextProps.fontFamily
    }
  }
});
const LOGOS = (_tokens) => {
  return extendsType()({
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/bestow-onLight.svg", "Bestow"),
        logoMark: getStaticAssetUrl("/Logos/bestow-icon-onLight.svg", "Bestow")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/bestow-onDark.svg", "Bestow"),
        logoMark: getStaticAssetUrl("/Logos/bestow-icon-onDark.svg", "Bestow")
      },
      auto: "onLight"
    }
  });
};
const PERCENTAGE_BAR = (tokens) => ({
  activeBg: tokens.colors.forms.fill.selectedHover,
  errorBg: tokens.colors.status.critical.default,
  borderRadius: "12px",
  height: "16px",
  color: tokens.colors.text.default,
  bg: tokens.colors.background.surface100,
  borderColor: tokens.colors.forms.border.default,
  borderWidth: "1px",
  borderStyle: "solid"
});
const SLIDER_INPUTS = (tokens, typography) => ({
  trackHeight: "6px",
  borderRadius: "3px",
  activeColor: tokens.colors.forms.fill.activated,
  inactiveColor: tokens.colors.forms.border.default,
  disabledColor: tokens.colors.forms.border.default,
  height: "30px",
  hideFeet: true,
  focusRingStyle: BASE_FOCUS(tokens),
  labelPosition: "above",
  labelStyle: {
    color: tokens.colors.text.default,
    ...typographyVariant("labelSmall.mobile", typography)
  },
  thumbStyle: {
    width: "50px",
    height: "30px",
    borderRadius: "15px",
    border: "0px solid transparent",
    boxShadow: `0 2px 4px rgba(0, 0, 0, 0.15)`,
    backgroundColor: tokens.colors.background.default,
    color: tokens.colors.icon.default,
    disabledColor: tokens.colors.iconInteraction.disabled,
    hoverStyle: {
      backgroundColor: tokens.colors.forms.fill.hover,
      borderWidth: "1px",
      borderColor: tokens.colors.forms.border.hover
    },
    activeStyle: {
      borderWidth: "2px",
      borderColor: tokens.colors.focus,
      backgroundColor: tokens.colors.forms.fill.pressed
    },
    focusRingStyle: BASE_FOCUS(tokens)
  }
});
const BANNERS = (tokens, typography) => ({
  ...typographyVariant("bodyMedium.desktop", typography),
  py: "12px",
  px: "24px",
  borderRadius: "4px",
  defaultVariant: "informationalWeak",
  variants: {
    informationalWeak: {
      bg: tokens.colors.background.informative.light,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    informational: {
      bg: tokens.colors.background.informative.default,
      color: tokens.colors.text.onColor,
      fill: tokens.colors.icon.onColor
    },
    successWeak: {
      bg: tokens.colors.status.success.light,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    success: {
      bg: tokens.colors.status.success.default,
      color: tokens.colors.text.onColor,
      fill: tokens.colors.icon.onColor
    },
    warningWeak: {
      bg: tokens.colors.status.warning.light,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    warning: {
      bg: tokens.colors.status.warning.default,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    errorWeak: {
      bg: tokens.colors.status.critical.light,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    error: {
      bg: tokens.colors.status.critical.default,
      color: tokens.colors.text.onColor,
      fill: tokens.colors.icon.onColor
    },
    neutralSubduedWeak: {
      bg: tokens.colors.background.surface200,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    }
  }
});
const MODALS = () => ({
  width: "640px",
  closeButtonSize: "36px",
  closeButtonMargin: "12px",
  backdropColor: "#000000",
  backdropOpacity: 0.6,
  borderRadius: "10px",
  closeButtonVariant: "outline",
  maxHeight: "85vh",
  responsive: {
    mobile: {
      maxHeight: "90vh"
    }
  },
  title: {
    paddingTop: "28px",
    paddingLeft: "20px",
    paddingBottom: "8px",
    paddingRight: "48px"
  },
  body: {
    paddingTop: "8px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "16px"
  },
  footer: {
    paddingTop: "16px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "24px"
  }
});
const MENU_ITEMS = (tokens, typography) => ({
  ...typographyVariant("bodySmall.mobile", typography),
  padding: `${tokens.spacing["6"]} ${tokens.spacing["16"]}`,
  color: tokens.colors.text.default,
  border: "solid 2px transparent",
  // In order to make the focussed border not "wiggle" the content, we account for the border ahead of time
  hoverStyle: {
    background: tokens.colors.forms.fill.hover
  },
  activeStyle: {
    background: tokens.colors.forms.fill.pressed
  },
  focusStyle: {
    border: `solid 2px ${tokens.colors.focus}`,
    borderRadius: "6px"
  },
  variants: {
    disabledStyle: {
      color: tokens.colors.links.disabled,
      hoverStyle: {
        background: tokens.colors.background.default
      }
    },
    selected: {
      ...typographyVariant("headerXSmall.mobile", typography)
    }
  }
});
const MENUS = (tokens) => ({
  background: tokens.colors.background.default,
  boxShadow: tokens.shadows.l2.bright,
  borderRadius: tokens.borders.radius["3"]
});
const TAGS = (tokens, typography) => ({
  ...typographyVariant("bodyXSmall.mobile", typography),
  borderRadius: "3px",
  paddingLeft: "8px",
  paddingTop: "5px",
  paddingBottom: "3px",
  paddingRight: "8px",
  defaultVariant: "gray",
  variants: {
    gray: {
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: tokens.colors.forms.border.default,
      fill: tokens.colors.icon.default,
      color: tokens.colors.text.default,
      background: "transparent",
      hoverStyle: {
        background: tokens.colors.forms.fill.hover,
        borderColor: tokens.colors.forms.border.hover
      },
      activeStyle: {
        background: tokens.colors.forms.fill.pressed,
        borderColor: tokens.colors.forms.border.pressed
      },
      disabledStyle: {
        background: tokens.colors.forms.fill.disabled,
        color: tokens.colors.forms.text.disabled,
        fill: tokens.colors.forms.text.disabled
      }
    }
  },
  focusRingStyle: {
    ...BASE_FOCUS(tokens),
    borderRadius: "1px",
    gap: "1px"
  }
});
const TOASTS = (tokens) => ({
  borderRadius: "6px",
  p: tokens.spacing["12"],
  leftIconSpacing: "14px",
  iconSize: "24px",
  lineHeight: "24px",
  sizes: {
    desktop: {
      fontSize: tokens.fonts.sizes["16"],
      width: "480px"
    },
    mobile: {
      fontSize: tokens.fonts.sizes["16"],
      width: "335px"
    }
  },
  variants: {
    info: {
      backgroundColor: tokens.colors.background.informative.light,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    warning: {
      backgroundColor: tokens.colors.status.warning.default,
      color: tokens.colors.text.default,
      fill: tokens.colors.text.default
    },
    success: {
      backgroundColor: tokens.colors.status.success.default,
      color: tokens.colors.text.onColor,
      fill: tokens.colors.text.onColor
    },
    danger: {
      backgroundColor: tokens.colors.status.critical.default,
      color: tokens.colors.text.onColor,
      fill: tokens.colors.text.onColor
    }
  }
});
const TOGGLE = (tokens, typography) => ({
  ...typographyVariant("bodySmall.mobile", typography),
  color: tokens.colors.text.default,
  borderRadius: "40px",
  width: "40px",
  height: "24px",
  circleSpacing: "4px",
  circleColor: tokens.colors.icon.onColor,
  transition: "all 100ms ease-in-out",
  disabledStyle: {
    background: tokens.colors.forms.fill.disabled
  },
  variants: {
    unselected: {
      background: tokens.colors.neutral["400"],
      hoverStyle: {
        background: tokens.colors.neutral["500"]
      }
    },
    selected: {
      background: tokens.colors.links.action.default,
      hoverStyle: {
        background: tokens.colors.links.action.hover
      }
    }
  },
  focusRingStyle: {
    ...BASE_FOCUS(tokens),
    gap: "1px"
  }
});
const SKELETONS = (tokens) => ({
  backgroundColor: tokens.colors.neutral["400"],
  highlightColor: tokens.colors.neutral["300"],
  variants: {
    text: {},
    circular: {},
    rectangular: {},
    rounded: {}
  }
});
const SPINNERS = (tokens) => ({
  trackColor: tokens.colors.background.surface200,
  spinnerColor: tokens.colors.background.brand,
  spinSpeed: "1s",
  defaultSize: "large",
  sizes: {
    large: {
      height: "56px",
      width: "56px"
    },
    medium: {
      height: "32px",
      width: "32px"
    },
    small: {
      height: "16px",
      width: "16px"
    }
  }
});
const POPOVERS = (tokens, typography) => ({
  borderRadius: "8px",
  color: tokens.colors.text.default,
  padding: tokens.spacing[16],
  maxWidth: "220px",
  zIndex: "3",
  defaultVariant: "card",
  variants: {
    card: {
      hideArrow: true,
      background: tokens.colors.background.default,
      borderRadius: "8px",
      color: tokens.colors.text.default,
      padding: tokens.spacing[16],
      boxShadow: `${tokens.shadows.l2.bright}, ${tokens.shadows.l2.dim}`,
      maxWidth: "220px"
    },
    tooltip: {
      ...typographyVariant("bodySmall.desktop", typography),
      hideArrow: false,
      // Explicitly show arrow for tooltip variant
      background: tokens.colors.neutral["900"],
      borderRadius: "4px",
      color: tokens.colors.text.onColor,
      fontWeight: tokens.fonts.weights.light,
      fontSize: tokens.fonts.sizes["14"],
      maxWidth: "200px",
      padding: `${tokens.spacing["8"]} ${tokens.spacing["12"]}`,
      lineHeight: tokens.fonts.lineHeights["140%"]
    }
  }
});
const CARDS = (tokens) => ({
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: tokens.colors.border.default,
  background: tokens.colors.background.default,
  boxShadow: tokens.shadows.l1.dim,
  borderRadius: "10px",
  gutters: {
    px: "24px"
  },
  headerStyles: {
    paddingTop: "24px",
    paddingBottom: "12px"
  },
  bodyStyles: {
    gap: "4px",
    py: "12px"
  },
  footerStyles: {
    py: "24px"
  },
  actionFooterStyles: {
    color: tokens.colors.links.action.default,
    fontWeight: tokens.fonts.weights.medium,
    fontSize: tokens.fonts.sizes[14],
    textAlign: "center",
    py: tokens.spacing[16],
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: tokens.colors.border.default,
    hoverStyle: {
      backgroundColor: tokens.colors.background.surface200,
      color: tokens.colors.links.action.hover,
      borderRadius: "0 0 6px 6px"
    },
    disabledStyle: {
      backgroundColor: "none",
      color: tokens.colors.links.disabled
    },
    activeStyle: {
      backgroundColor: tokens.colors.background.default,
      color: tokens.colors.links.action.pressed
    },
    focusRingStyle: BASE_FOCUS(tokens)
  }
});
const STEPPER = (tokens) => ({
  background: {
    complete: tokens.colors.status.success.default,
    incomplete: tokens.colors.neutral["0"],
    active: tokens.colors.neutral["0"],
    stalled: tokens.colors.neutral["0"],
    failed: tokens.colors.status.critical.default
  },
  borders: {
    complete: tokens.colors.status.success.default,
    incomplete: tokens.colors.border.default,
    active: tokens.colors.status.success.default,
    stalled: tokens.colors.status.warning.default,
    failed: tokens.colors.status.critical.default
  },
  icons: {
    complete: tokens.colors.neutral["0"],
    incomplete: tokens.colors.border.default,
    active: tokens.colors.status.success.default,
    stalled: tokens.colors.status.warning.default,
    failed: tokens.colors.neutral["0"]
  },
  defaultSize: "large",
  sizes: {
    small: {
      circleSize: "18px",
      iconSize: "10px",
      circleBorderWidth: "1px",
      lineWidth: "1px",
      bodyMarginLeft: "24px",
      bodyMarginTop: "0px",
      dateTop: "0px",
      titleVariant: "headerSmall",
      titleFontWeight: tokens.fonts.weights.semibold,
      descriptionVariant: "bodySmall"
    },
    large: {
      circleSize: "40px",
      iconSize: "24px",
      circleBorderWidth: "2px",
      lineWidth: "2px",
      bodyMarginLeft: "16px",
      bodyMarginTop: tokens.spacing["4"],
      dateTop: tokens.spacing["8"],
      titleVariant: "labelXSmall",
      titleFontWeight: tokens.fonts.weights.semibold,
      descriptionVariant: "bodyMedium"
    }
  }
});
const SIGNATURE = (_tokens) => ({
  background: {
    default: "#E9F1FA",
    hover: "#9EC3E5",
    disabled: "#E8E8E8"
  },
  borderColor: {
    default: "#0465AA",
    hover: "#024678",
    disabled: "#BBBBBB"
  },
  textColor: {
    disabled: "#6F7276"
  }
});
const DRAWER = (_tokens) => ({
  boxShadow: _tokens.shadows.l3.dim,
  background: _tokens.colors.background.default
});
const ACCORDION = (_tokens) => ({
  display: "flex",
  flexDirection: "column"
});
const ACCORDION_ITEM = (_tokens) => ({
  display: "flex",
  flexDirection: "column"
});
const ACCORDION_TRIGGER = (_tokens) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "none",
  background: "unset",
  padding: _tokens.spacing[24],
  width: "100%"
});
const ACCORDION_BODY = (_tokens) => ({
  paddingLeft: _tokens.spacing[24],
  paddingRight: _tokens.spacing[24],
  paddingBottom: _tokens.spacing[24]
});
const FILE_UPLOAD_CONTAINER = (_tokens) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start"
});
const FILE_UPLOAD_TRIGGER = (_tokens) => ({
  backgroundColor: "transparent",
  border: "none",
  margin: `${_tokens.spacing[8]} 0`
});
const HIGHLIGHTED_CHECKBOX = (tokens) => ({
  background: {
    default: "#E9F1FA",
    hover: "#9EC3E5",
    disabled: "#E8E8E8",
    invalid: "#DAEEF8"
  },
  background_image_color: {
    default: "#0465AA",
    hover: "#024678",
    disabled: "#BBBBBB",
    invalid: "#0465AA"
  },
  outline: {
    focus: tokens.colors.focus
  },
  textColor: {
    disabled: "#6F7276"
  }
});
const TAB_NAVIGATION = (tokens, typography) => {
  const linkColors = tokens.colors.links;
  return {
    ...typographyVariant("headerXSmall.desktop", typography),
    color: tokens.colors.text.default,
    fill: linkColors.action.default,
    hoverStyle: {
      color: linkColors.action.hover,
      fill: linkColors.action.hover
    },
    activeStyle: {
      color: linkColors.action.pressed,
      fill: linkColors.action.pressed
    },
    disabledStyle: {
      color: linkColors.disabled,
      fill: linkColors.disabled
    },
    focusRingStyle: BASE_FOCUS(tokens)
  };
};
const FILTER_TRIGGER = (tokens) => ({
  color: tokens.colors.text.default,
  borderRadius: tokens.borders.radius[4],
  background: tokens.colors.background.surface100,
  padding: `${tokens.spacing["8"]} ${tokens.spacing["12"]}`,
  focusStyle: {
    width: tokens.spacing["2"],
    color: tokens.colors.focus,
    borderRadius: tokens.borders.radius[4],
    background: tokens.colors.background.surface200
  },
  hoverStyle: {
    background: tokens.colors.buttons.ghost.fill.pressed
  },
  activeStyle: {
    background: tokens.colors.buttons.ghost.fill.pressed
  }
});
const FILTER_ITEM = (tokens) => ({
  borderRadius: tokens.borders.radius[6],
  variants: {
    expanded: {
      background: tokens.colors.background.surface100
    },
    collapsed: {
      background: "unset"
    }
  }
});
const baseRequiredUnusedProps = {
  local: {
    carouselBackground: "",
    layoutBackgroundColor: void 0,
    appContainerTopPadding: void 0,
    formBackgroundColor: void 0,
    formSimplificationHeaderTextColor: void 0,
    fullwidth: void 0,
    headerBackgroundColor: void 0,
    headerBoxShadow: void 0,
    headerIconColor: void 0,
    headerLogoVariant: void 0,
    noCardBackgroundOnForms: void 0,
    reduceHeaderDesktopPadding: void 0,
    navBackgroundAutoColor: void 0,
    navTextAutoColor: void 0,
    navBorderAutoColor: void 0
  },
  header: void 0
};
const buildBaseTheme = (tokens, typography) => {
  return {
    // Base props
    ...baseRequiredUnusedProps,
    // Tokens
    ...tokens,
    // Remap the tokens to some flatter values
    fontWeight: tokens.fonts.weights,
    lineHeight: tokens.fonts.lineHeights,
    fontSize: tokens.fonts.sizes,
    fontsToLoad: tokens.fonts.fontsToLoad,
    borderWidth: tokens.borders.width,
    borderRadius: tokens.borders.radius,
    borderColors: tokens.borders.colors,
    // components
    accordion: ACCORDION(),
    accordionTrigger: ACCORDION_TRIGGER(tokens),
    accordionBody: ACCORDION_BODY(tokens),
    accordionItem: ACCORDION_ITEM(),
    fileUploadContainer: FILE_UPLOAD_CONTAINER(),
    fileUploadTrigger: FILE_UPLOAD_TRIGGER(tokens),
    percentageBar: PERCENTAGE_BAR(tokens),
    divider: DIVIDERS(tokens),
    drawer: DRAWER(tokens),
    badges: BADGES(tokens),
    banners: BANNERS(tokens, typography),
    buttons: BUTTONS(tokens, typography),
    buttonGroup: BUTTON_GROUP(tokens, typography),
    links: BESTOW_LINKS(tokens, typography),
    logos: LOGOS(),
    inputs: INPUTS(tokens, typography),
    sliderInput: SLIDER_INPUTS(tokens, typography),
    tags: TAGS(tokens, typography),
    toggle: TOGGLE(tokens, typography),
    toasts: TOASTS(tokens),
    popovers: POPOVERS(tokens, typography),
    typography,
    focusRingStyle: BASE_FOCUS(tokens),
    menu_items: MENU_ITEMS(tokens, typography),
    menus: MENUS(tokens),
    modals: MODALS(),
    spinners: SPINNERS(tokens),
    skeletons: SKELETONS(tokens),
    card: CARDS(tokens),
    stepper: STEPPER(tokens),
    signature: SIGNATURE(),
    highlightedCheckbox: HIGHLIGHTED_CHECKBOX(tokens),
    tabNavigation: TAB_NAVIGATION(tokens, typography),
    filterTrigger: FILTER_TRIGGER(tokens),
    filterItem: FILTER_ITEM(tokens)
  };
};
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function _interopDefault$1(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
var React = React__default$1;
var React__default = _interopDefault$1(React);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function withSideEffect(reducePropsToState3, handleStateChangeOnClient, mapStateOnServer3) {
  if (typeof reducePropsToState3 !== "function") {
    throw new Error("Expected reducePropsToState to be a function.");
  }
  if (typeof handleStateChangeOnClient !== "function") {
    throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  if (typeof mapStateOnServer3 !== "undefined" && typeof mapStateOnServer3 !== "function") {
    throw new Error("Expected mapStateOnServer to either be undefined or a function.");
  }
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }
  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== "function") {
      throw new Error("Expected WrappedComponent to be a React component.");
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState3(mountedInstances.map(function(instance) {
        return instance.props;
      }));
      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer3) {
        state = mapStateOnServer3(state);
      }
    }
    var SideEffect = /* @__PURE__ */ function(_PureComponent) {
      _inheritsLoose(SideEffect2, _PureComponent);
      function SideEffect2() {
        return _PureComponent.apply(this, arguments) || this;
      }
      SideEffect2.peek = function peek() {
        return state;
      };
      SideEffect2.rewind = function rewind() {
        if (SideEffect2.canUseDOM) {
          throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
        }
        var recordedState = state;
        state = void 0;
        mountedInstances = [];
        return recordedState;
      };
      var _proto = SideEffect2.prototype;
      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };
      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };
      return SideEffect2;
    }(React.PureComponent);
    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
    return SideEffect;
  };
}
var lib = withSideEffect;
var withSideEffect$1 = /* @__PURE__ */ getDefaultExportFromCjs(lib);
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == "object" && typeof b == "object") {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; )
        if (!equal(a[i], b[i])) return false;
      return true;
    }
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; )
        if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    if (hasElementType && a instanceof Element) return false;
    for (i = length; i-- !== 0; ) {
      if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
        continue;
      }
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    return true;
  }
  return a !== a && b !== b;
}
var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error;
  }
};
var isEqual2 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare);
var objectAssignExports = requireObjectAssign();
var assign = /* @__PURE__ */ getDefaultExportFromCjs(objectAssignExports);
var ATTRIBUTE_NAMES = {
  BODY: "bodyAttributes",
  HTML: "htmlAttributes",
  TITLE: "titleAttributes"
};
var TAG_NAMES = {
  BASE: "base",
  BODY: "body",
  HEAD: "head",
  HTML: "html",
  LINK: "link",
  META: "meta",
  NOSCRIPT: "noscript",
  SCRIPT: "script",
  STYLE: "style",
  TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function(name) {
  return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
  CHARSET: "charset",
  CSS_TEXT: "cssText",
  HREF: "href",
  HTTPEQUIV: "http-equiv",
  INNER_HTML: "innerHTML",
  ITEM_PROP: "itemprop",
  NAME: "name",
  PROPERTY: "property",
  REL: "rel",
  SRC: "src",
  TARGET: "target"
};
var REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
};
var HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function(obj, key) {
  obj[REACT_TAG_MAP[key]] = key;
  return obj;
}, {});
var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
var HELMET_ATTRIBUTE = "data-react-helmet";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = /* @__PURE__ */ function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
};
var possibleConstructorReturn = function(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
};
var encodeSpecialCharacters = function encodeSpecialCharacters2(str) {
  var encode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (encode === false) {
    return String(str);
  }
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var getTitleFromPropsList = function getTitleFromPropsList2(propsList) {
  var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
  if (innermostTemplate && innermostTitle) {
    return innermostTemplate.replace(/%s/g, function() {
      return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
  }
  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
  return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = function getOnChangeClientState2(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {
  };
};
var getAttributesFromPropsList = function getAttributesFromPropsList2(tagType, propsList) {
  return propsList.filter(function(props) {
    return typeof props[tagType] !== "undefined";
  }).map(function(props) {
    return props[tagType];
  }).reduce(function(tagAttrs, current) {
    return _extends({}, tagAttrs, current);
  }, {});
};
var getBaseTagFromPropsList = function getBaseTagFromPropsList2(primaryAttributes, propsList) {
  return propsList.filter(function(props) {
    return typeof props[TAG_NAMES.BASE] !== "undefined";
  }).map(function(props) {
    return props[TAG_NAMES.BASE];
  }).reverse().reduce(function(innermostBaseTag, tag) {
    if (!innermostBaseTag.length) {
      var keys = Object.keys(tag);
      for (var i = 0; i < keys.length; i++) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag);
        }
      }
    }
    return innermostBaseTag;
  }, []);
};
var getTagsFromPropsList = function getTagsFromPropsList2(tagName, primaryAttributes, propsList) {
  var approvedSeenTags = {};
  return propsList.filter(function(props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }
    if (typeof props[tagName] !== "undefined") {
      warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + _typeof(props[tagName]) + '"');
    }
    return false;
  }).map(function(props) {
    return props[tagName];
  }).reverse().reduce(function(approvedTags, instanceTags) {
    var instanceSeenTags = {};
    instanceTags.filter(function(tag) {
      var primaryAttributeKey = void 0;
      var keys2 = Object.keys(tag);
      for (var i2 = 0; i2 < keys2.length; i2++) {
        var attributeKey2 = keys2[i2];
        var lowerCaseAttributeKey = attributeKey2.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
          primaryAttributeKey = lowerCaseAttributeKey;
        }
        if (primaryAttributes.indexOf(attributeKey2) !== -1 && (attributeKey2 === TAG_PROPERTIES.INNER_HTML || attributeKey2 === TAG_PROPERTIES.CSS_TEXT || attributeKey2 === TAG_PROPERTIES.ITEM_PROP)) {
          primaryAttributeKey = attributeKey2;
        }
      }
      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }
      var value = tag[primaryAttributeKey].toLowerCase();
      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }
      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }
      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }
      return false;
    }).reverse().forEach(function(tag) {
      return approvedTags.push(tag);
    });
    var keys = Object.keys(instanceSeenTags);
    for (var i = 0; i < keys.length; i++) {
      var attributeKey = keys[i];
      var tagUnion = assign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
      approvedSeenTags[attributeKey] = tagUnion;
    }
    return approvedTags;
  }, []).reverse();
};
var getInnermostProperty = function getInnermostProperty2(propsList, property) {
  for (var i = propsList.length - 1; i >= 0; i--) {
    var props = propsList[i];
    if (props.hasOwnProperty(property)) {
      return props[property];
    }
  }
  return null;
};
var reducePropsToState = function reducePropsToState2(propsList) {
  return {
    baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
    bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
    linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
    metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
    noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
    styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
  };
};
var rafPolyfill = function() {
  var clock = Date.now();
  return function(callback) {
    var currentTime = Date.now();
    if (currentTime - clock > 16) {
      clock = currentTime;
      callback(currentTime);
    } else {
      setTimeout(function() {
        rafPolyfill(callback);
      }, 0);
    }
  };
}();
var cafPolyfill = function cafPolyfill2(id) {
  return clearTimeout(id);
};
var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
var warn = function warn2(msg) {
  return console && typeof console.warn === "function" && console.warn(msg);
};
var _helmetCallback = null;
var handleClientStateChange = function handleClientStateChange2(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }
  if (newState.defer) {
    _helmetCallback = requestAnimationFrame(function() {
      commitTagChanges(newState, function() {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};
var commitTagChanges = function commitTagChanges2(newState, cb) {
  var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
  updateAttributes(TAG_NAMES.BODY, bodyAttributes);
  updateAttributes(TAG_NAMES.HTML, htmlAttributes);
  updateTitle(title, titleAttributes);
  var tagUpdates = {
    baseTag: updateTags(TAG_NAMES.BASE, baseTag),
    linkTags: updateTags(TAG_NAMES.LINK, linkTags),
    metaTags: updateTags(TAG_NAMES.META, metaTags),
    noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
    scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
    styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
  };
  var addedTags = {};
  var removedTags = {};
  Object.keys(tagUpdates).forEach(function(tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
    if (newTags.length) {
      addedTags[tagType] = newTags;
    }
    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });
  cb && cb();
  onChangeClientState(newState, addedTags, removedTags);
};
var flattenArray = function flattenArray2(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var updateTitle = function updateTitle2(title, attributes) {
  if (typeof title !== "undefined" && document.title !== title) {
    document.title = flattenArray(title);
  }
  updateAttributes(TAG_NAMES.TITLE, attributes);
};
var updateAttributes = function updateAttributes2(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];
  if (!elementTag) {
    return;
  }
  var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
  var attributesToRemove = [].concat(helmetAttributes);
  var attributeKeys = Object.keys(attributes);
  for (var i = 0; i < attributeKeys.length; i++) {
    var attribute = attributeKeys[i];
    var value = attributes[attribute] || "";
    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }
    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }
    var indexToSave = attributesToRemove.indexOf(attribute);
    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }
  for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
    elementTag.removeAttribute(attributesToRemove[_i]);
  }
  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
    elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
  }
};
var updateTags = function updateTags2(type, tags) {
  var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
  var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
  var oldTags = Array.prototype.slice.call(tagNodes);
  var newTags = [];
  var indexToDelete = void 0;
  if (tags && tags.length) {
    tags.forEach(function(tag) {
      var newElement = document.createElement(type);
      for (var attribute in tag) {
        if (tag.hasOwnProperty(attribute)) {
          if (attribute === TAG_PROPERTIES.INNER_HTML) {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
            newElement.setAttribute(attribute, value);
          }
        }
      }
      newElement.setAttribute(HELMET_ATTRIBUTE, "true");
      if (oldTags.some(function(existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }
  oldTags.forEach(function(tag) {
    return tag.parentNode.removeChild(tag);
  });
  newTags.forEach(function(tag) {
    return headElement.appendChild(tag);
  });
  return {
    oldTags,
    newTags
  };
};
var generateElementAttributesAsString = function generateElementAttributesAsString2(attributes) {
  return Object.keys(attributes).reduce(function(str, key) {
    var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
    return str ? str + " " + attr : attr;
  }, "");
};
var generateTitleAsString = function generateTitleAsString2(type, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = flattenArray(title);
  return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + '="true">' + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var generateTagsAsString = function generateTagsAsString2(type, tags, encode) {
  return tags.reduce(function(str, tag) {
    var attributeHtml = Object.keys(tag).filter(function(attribute) {
      return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
    }).reduce(function(string, attribute) {
      var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + encodeSpecialCharacters(tag[attribute], encode) + '"';
      return string ? string + " " + attr : attr;
    }, "");
    var tagContent = tag.innerHTML || tag.cssText || "";
    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
    return str + "<" + type + " " + HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
  }, "");
};
var convertElementAttributestoReactProps = function convertElementAttributestoReactProps2(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Object.keys(attributes).reduce(function(obj, key) {
    obj[REACT_TAG_MAP[key] || key] = attributes[key];
    return obj;
  }, initProps);
};
var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes2(props) {
  var initAttributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Object.keys(props).reduce(function(obj, key) {
    obj[HTML_TAG_MAP[key] || key] = props[key];
    return obj;
  }, initAttributes);
};
var generateTitleAsReactComponent = function generateTitleAsReactComponent2(type, title, attributes) {
  var _initProps;
  var initProps = (_initProps = {
    key: title
  }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
  var props = convertElementAttributestoReactProps(attributes, initProps);
  return [React__default$1.createElement(TAG_NAMES.TITLE, props, title)];
};
var generateTagsAsReactComponent = function generateTagsAsReactComponent2(type, tags) {
  return tags.map(function(tag, i) {
    var _mappedTag;
    var mappedTag = (_mappedTag = {
      key: i
    }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
    Object.keys(tag).forEach(function(attribute) {
      var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
      if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
        var content = tag.innerHTML || tag.cssText;
        mappedTag.dangerouslySetInnerHTML = { __html: content };
      } else {
        mappedTag[mappedAttribute] = tag[attribute];
      }
    });
    return React__default$1.createElement(type, mappedTag);
  });
};
var getMethodsForTag = function getMethodsForTag2(type, tags, encode) {
  switch (type) {
    case TAG_NAMES.TITLE:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
        },
        toString: function toString2() {
          return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
        }
      };
    case ATTRIBUTE_NAMES.BODY:
    case ATTRIBUTE_NAMES.HTML:
      return {
        toComponent: function toComponent() {
          return convertElementAttributestoReactProps(tags);
        },
        toString: function toString2() {
          return generateElementAttributesAsString(tags);
        }
      };
    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type, tags);
        },
        toString: function toString2() {
          return generateTagsAsString(type, tags, encode);
        }
      };
  }
};
var mapStateOnServer = function mapStateOnServer2(_ref) {
  var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
  return {
    base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
    bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
    link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
    meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
    noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
    script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
    style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
    title: getMethodsForTag(TAG_NAMES.TITLE, { title, titleAttributes }, encode)
  };
};
var Helmet = function Helmet2(Component) {
  var _class, _temp;
  return _temp = _class = function(_React$Component) {
    inherits(HelmetWrapper, _React$Component);
    function HelmetWrapper() {
      classCallCheck(this, HelmetWrapper);
      return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return !isEqual2(this.props, nextProps);
    };
    HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }
      switch (child.type) {
        case TAG_NAMES.SCRIPT:
        case TAG_NAMES.NOSCRIPT:
          return {
            innerHTML: nestedChildren
          };
        case TAG_NAMES.STYLE:
          return {
            cssText: nestedChildren
          };
      }
      throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    };
    HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
      var _babelHelpers$extends;
      var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
      return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
    };
    HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
      var _babelHelpers$extends2, _babelHelpers$extends3;
      var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
      switch (child.type) {
        case TAG_NAMES.TITLE:
          return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
        case TAG_NAMES.BODY:
          return _extends({}, newProps, {
            bodyAttributes: _extends({}, newChildProps)
          });
        case TAG_NAMES.HTML:
          return _extends({}, newProps, {
            htmlAttributes: _extends({}, newChildProps)
          });
      }
      return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
    };
    HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _extends({}, newProps);
      Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
        var _babelHelpers$extends4;
        newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
      });
      return newFlattenedProps;
    };
    HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
      if (process.env.NODE_ENV !== "production") {
        if (!VALID_TAG_NAMES.some(function(name) {
          return child.type === name;
        })) {
          if (typeof child.type === "function") {
            return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
          }
          return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
        }
        if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function(nestedChild) {
          return typeof nestedChild !== "string";
        }))) {
          throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
        }
      }
      return true;
    };
    HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
      var _this2 = this;
      var arrayTypeChildren = {};
      React__default$1.Children.forEach(children, function(child) {
        if (!child || !child.props) {
          return;
        }
        var _child$props = child.props, nestedChildren = _child$props.children, childProps = objectWithoutProperties(_child$props, ["children"]);
        var newChildProps = convertReactPropstoHtmlAttributes(childProps);
        _this2.warnOnInvalidChildren(child, nestedChildren);
        switch (child.type) {
          case TAG_NAMES.LINK:
          case TAG_NAMES.META:
          case TAG_NAMES.NOSCRIPT:
          case TAG_NAMES.SCRIPT:
          case TAG_NAMES.STYLE:
            arrayTypeChildren = _this2.flattenArrayTypeChildren({
              child,
              arrayTypeChildren,
              newChildProps,
              nestedChildren
            });
            break;
          default:
            newProps = _this2.mapObjectTypeChildren({
              child,
              newProps,
              newChildProps,
              nestedChildren
            });
            break;
        }
      });
      newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
      return newProps;
    };
    HelmetWrapper.prototype.render = function render() {
      var _props = this.props, children = _props.children, props = objectWithoutProperties(_props, ["children"]);
      var newProps = _extends({}, props);
      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }
      return React__default$1.createElement(Component, newProps);
    };
    createClass(HelmetWrapper, null, [{
      key: "canUseDOM",
      // Component.peek comes from react-side-effect:
      // For testing, you may use a static peek() method available on the returned component.
      // It lets you get the current state without resetting the mounted instance stack.
      // Don’t use it for anything other than testing.
      /**
       * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
       * @param {Object} bodyAttributes: {"className": "root"}
       * @param {String} defaultTitle: "Default Title"
       * @param {Boolean} defer: true
       * @param {Boolean} encodeSpecialCharacters: true
       * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
       * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
       * @param {Array} meta: [{"name": "description", "content": "Test description"}]
       * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
       * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
       * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
       * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
       * @param {String} title: "Title"
       * @param {Object} titleAttributes: {"itemprop": "name"}
       * @param {String} titleTemplate: "MySite.com - %s"
       */
      set: function set$$1(canUseDOM2) {
        Component.canUseDOM = canUseDOM2;
      }
    }]);
    return HelmetWrapper;
  }(React__default$1.Component), _class.propTypes = {
    base: PropTypes.object,
    bodyAttributes: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    defaultTitle: PropTypes.string,
    defer: PropTypes.bool,
    encodeSpecialCharacters: PropTypes.bool,
    htmlAttributes: PropTypes.object,
    link: PropTypes.arrayOf(PropTypes.object),
    meta: PropTypes.arrayOf(PropTypes.object),
    noscript: PropTypes.arrayOf(PropTypes.object),
    onChangeClientState: PropTypes.func,
    script: PropTypes.arrayOf(PropTypes.object),
    style: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    titleAttributes: PropTypes.object,
    titleTemplate: PropTypes.string
  }, _class.defaultProps = {
    defer: true,
    encodeSpecialCharacters: true
  }, _class.peek = Component.peek, _class.rewind = function() {
    var mappedState = Component.rewind();
    if (!mappedState) {
      mappedState = mapStateOnServer({
        baseTag: [],
        bodyAttributes: {},
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
      });
    }
    return mappedState;
  }, _temp;
};
var NullComponent = function NullComponent2() {
  return null;
};
var HelmetSideEffects = withSideEffect$1(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;
const FONT_FILE_MAPPINGS = {
  Rotunda: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/Rotunda/Rotunda.css`
  },
  PlayfairDisplay: {
    type: "googleFont",
    fontQueryString: "family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900"
  },
  Caveat: {
    type: "googleFont",
    fontQueryString: "family=Caveat:wght@400;500;600;700"
  },
  Montserrat: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/Montserrat/Montserrat.css`
  },
  GTAmerica: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/GTAmerica/GTAmerica.css`
  },
  Inter: {
    type: "googleFont",
    fontQueryString: "family=Inter:wght@100;200;300;400;500;600;700;800;900"
  },
  B612Mono: {
    type: "googleFont",
    fontQueryString: "family=B612+Mono:ital,wght@0,400;0,700;1,400;1,700"
  },
  DMSerifDisplay: {
    type: "googleFont",
    fontQueryString: "DM+Serif+Display:ital@0;1"
  },
  Assistant: {
    type: "googleFont",
    fontQueryString: "family=Assistant:wght@200;300;400;500;600;700;800"
  },
  "Open Sans": {
    type: "googleFont",
    fontQueryString: "family=Open+Sans:wght@200;300;400;500;600;700;800"
  },
  Arial: {
    type: "systemFont"
  },
  Georgia: {
    type: "systemFont"
  },
  "Gotham Narrow": {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/Gotham/GothamNarrow.css`
  },
  Whitney: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/Whitney/Whitney.css`
  },
  PerfectlyNineties: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/PerfectlyNineties/PerfectlyNineties.css`
  },
  OpenSansCondensed: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/OpenSansCondensed/OpenSansCondensed.css`
  },
  LibreCaslonText: {
    type: "linkFont",
    linkFunction: (env) => `${BASE_STATIC_BUCKET_MAP[env]}/fonts/LibreCaslonText/LibreCaslonText.css`
  },
  Figtree: {
    type: "googleFont",
    fontQueryString: "family=Figtree:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900"
  }
};
var FontLoaderFonts = /* @__PURE__ */ ((FontLoaderFonts2) => {
  FontLoaderFonts2["Rotunda"] = "Rotunda";
  FontLoaderFonts2["PlayfairDisplay"] = "PlayfairDisplay";
  FontLoaderFonts2["Caveat"] = "Caveat";
  FontLoaderFonts2["Montserrat"] = "Montserrat";
  FontLoaderFonts2["GTAmerica"] = "GTAmerica";
  FontLoaderFonts2["Inter"] = "Inter";
  FontLoaderFonts2["B612Mono"] = "B612Mono";
  FontLoaderFonts2["DMSerifDisplay"] = "DMSerifDisplay";
  FontLoaderFonts2["Assistant"] = "Assistant";
  FontLoaderFonts2["Arial"] = "Arial";
  FontLoaderFonts2["Georgia"] = "Georgia";
  FontLoaderFonts2["Gotham Narrow"] = "Gotham Narrow";
  FontLoaderFonts2["Whitney"] = "Whitney";
  FontLoaderFonts2["Open Sans"] = "Open Sans";
  FontLoaderFonts2["OpenSansCondensed"] = "OpenSansCondensed";
  FontLoaderFonts2["PerfectlyNineties"] = "PerfectlyNineties";
  FontLoaderFonts2["Figtree"] = "Figtree";
  FontLoaderFonts2["LibreCaslonText"] = "LibreCaslonText";
  return FontLoaderFonts2;
})(FontLoaderFonts || {});
const defaultFontSizeCSS = css`
  html {
    /* Set base 1rem = 16px */
    font-size: 16px;
  }
`;
const buildGoogleFontQueryString = (googleFonts) => googleFonts.map(({
  fontQueryString
}) => fontQueryString).join("&");
const linksForTheme = (theme, env = "production") => {
  if ("fontsToLoad" in theme) {
    const links = [];
    theme.fontsToLoad.forEach((fontName) => {
      if (!Object.keys(FontLoaderFonts).includes(fontName)) {
        console.error(`Unsupported font sent to Kindred font loader named: "${fontName}"`);
      }
    });
    const fonts = theme.fontsToLoad.map((font) => FONT_FILE_MAPPINGS[font]);
    const linkFonts = fonts.filter((font) => font.type === "linkFont");
    const googleFonts = fonts.filter((font) => font.type === "googleFont");
    const googleFontQueryString = buildGoogleFontQueryString(googleFonts);
    linkFonts.forEach((font) => {
      const href = font.linkFunction(env);
      links.push({
        key: href,
        rel: "stylesheet",
        href
      });
    });
    if (googleFontQueryString) {
      links.push({
        key: "google-fonts",
        rel: "stylesheet",
        href: `https://fonts.googleapis.com/css2?display=swap&${googleFontQueryString}`
      }, {
        key: "preconnect-google-fonts",
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
      }, {
        key: "preconnect-google-fonts-gstatic",
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "anonymous"
      });
    }
    return links;
  }
  return [];
};
const FontLoader = ({
  env = "production"
}) => {
  const theme = useTheme();
  if ("fontsToLoad" in theme) {
    const links = linksForTheme(theme, env);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(HelmetExport, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: defaultFontSizeCSS.join("") }),
      links.map((link) => /* @__PURE__ */ jsxRuntimeExports.jsx("link", { rel: link.rel, href: link.href, crossOrigin: link.crossOrigin }, link.key))
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, {});
};
const purple = {
  // brand colors
  50: "#F9F7FF",
  100: "#EFEBFA",
  200: "#DBD1F0",
  300: "#C9B8EB",
  400: "#A68CD9",
  500: "#8560D0",
  600: "#663DB8",
  700: "#523194",
  800: "#402673",
  900: "#2D1758"
};
const GRADIENTS = extendsType()({
  g1: "linear-gradient(118.17deg, #0B3741 32.78%, #936293 84.57%, #E48580 108.69%), #FAF5F0",
  g2: "linear-gradient(117.04deg, #0B3741 30.16%, #59476B 100%)",
  g4: "linear-gradient(118.29deg, #402673 0%, #177482 106.51%), #FAF5F0",
  g5: "conic-gradient(from 212.92deg at 52.16% 55.29%, #5A49AB 0deg, #177482 176.87deg, #332673 360deg), #FAF5F0",
  svg: {
    g1: {
      id: "purple_g1_gradient"
    },
    g2: {
      id: "purple_g2_gradient"
    }
  }
});
const baseColors = merge({}, BASE_COLOR_SCALES, {
  purple,
  strawberry: {
    100: "#EEA9A0",
    200: "#E57D76",
    // main color of the group
    300: "#EB5850",
    400: "#950404"
  },
  gold: {
    100: "#FCD99C",
    200: "#FBC66A",
    // main color of the group
    300: "#FAB53E",
    400: "#C9840D"
  },
  neutral: {
    bone: "#F8F4F2"
  },
  bone: "#F8F4F2",
  charcoal: BASE_COLOR_SCALES.neutral["900"],
  navy: BASE_COLOR_SCALES.blue["900"],
  grimace: purple["600"],
  cloud: BASE_COLOR_SCALES.neutral["50"],
  robinsEgg: BASE_COLOR_SCALES.blue["400"],
  ocean: BASE_COLOR_SCALES.blue["700"]
});
const purpleEnterpriseColors = {
  // TODO: [FEP-530] - delete this
  brand: purple,
  text: {
    headline: baseColors.navy,
    default: baseColors.neutral["900"],
    subdued: "#6e6b68",
    onColor: baseColors.neutral["0"]
  },
  avatars: [{
    backgroundColor: baseColors.blue[900],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.blue[700],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.blue[500],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.blue[400],
    color: baseColors.charcoal
  }, {
    backgroundColor: baseColors.blue[300],
    color: baseColors.charcoal
  }, {
    backgroundColor: baseColors.purple[600],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.purple[500],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.purple[400],
    color: baseColors.charcoal
  }, {
    backgroundColor: baseColors.strawberry[300],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.strawberry[200],
    color: baseColors.charcoal
  }, {
    backgroundColor: baseColors.strawberry[100],
    color: baseColors.charcoal
  }, {
    backgroundColor: baseColors.gold[400],
    color: baseColors.charcoal
  }, {
    backgroundColor: baseColors.gold[300],
    color: baseColors.neutral[0]
  }, {
    backgroundColor: baseColors.gold[100],
    color: baseColors.charcoal
  }],
  background: {
    default: baseColors.neutral["0"],
    surface100: baseColors.neutral["50"],
    surface200: baseColors.neutral["200"],
    brand: baseColors.navy,
    accentConsumer: GRADIENTS.g2,
    accentEnterprise: GRADIENTS.g4,
    informative: {
      default: baseColors.blue["900"],
      light: baseColors.blue["100"]
    }
  },
  navigation: {
    backgroundAuto: baseColors.neutral["0"],
    borderAuto: baseColors.neutral["400"],
    textAuto: baseColors.navy
  },
  border: {
    default: baseColors.neutral["400"],
    brand: baseColors.grimace,
    onColor: curriedTransparentize$1(0.8, baseColors.neutral["0"]),
    // 20% opacity
    destructive: baseColors.red["600"]
  },
  icon: {
    default: baseColors.neutral["900"],
    subdued: baseColors.neutral["700"],
    onColor: baseColors.neutral["0"],
    brand: baseColors.navy
  },
  status: {
    success: {
      default: baseColors.green["500"],
      light: baseColors.green["50"],
      dark: baseColors.green["700"]
    },
    critical: {
      default: baseColors.red["600"],
      light: baseColors.red["50"],
      dark: baseColors.red["700"]
    },
    warning: {
      default: baseColors.yellow["400"],
      light: baseColors.yellow["150"],
      dark: baseColors.yellow["700"]
    }
  },
  focus: baseColors.purple["600"],
  buttons: {
    primary: {
      fill: {
        default: baseColors.purple["600"],
        hover: baseColors.purple["500"],
        pressed: baseColors.purple["800"],
        disabled: baseColors.neutral["300"]
      },
      text: {
        default: baseColors.neutral["0"],
        disabled: baseColors.neutral["500"]
      }
    },
    secondary: {
      fill: {
        default: "transparent",
        hover: baseColors.purple["200"],
        pressed: baseColors.purple["300"],
        disabled: "transparent"
      },
      text: {
        default: baseColors.purple["800"],
        disabled: baseColors.neutral["500"]
      },
      border: {
        default: baseColors.purple["800"],
        hover: baseColors.purple["800"],
        disabled: baseColors.neutral["500"]
      }
    },
    ghost: {
      focus: baseColors.purple["600"],
      fill: {
        default: "transparent",
        hover: baseColors.blue["50"],
        pressed: baseColors.blue["100"],
        disabled: baseColors.neutral["300"]
      },
      text: {
        default: baseColors.blue["900"],
        disabled: baseColors.neutral["500"]
      }
    },
    destructive: {
      focus: baseColors.red["600"],
      primary: {
        fill: {
          default: baseColors.red["600"],
          hover: "#F33329",
          pressed: baseColors.red["700"],
          disabled: baseColors.neutral["300"]
        },
        text: {
          default: baseColors.neutral["0"],
          disabled: baseColors.neutral["500"]
        }
      },
      secondary: {
        fill: {
          default: "transparent",
          hover: baseColors.red["50"],
          pressed: baseColors.red["100"]
        },
        text: {
          default: baseColors.red["700"],
          disabled: baseColors.neutral["500"]
        },
        border: {
          default: baseColors.red["700"],
          disabled: baseColors.neutral["500"]
        }
      },
      ghost: {
        focus: baseColors.red["600"],
        fill: {
          hover: baseColors.red["100"],
          pressed: baseColors.red["200"]
        },
        text: {
          default: baseColors.red["700"],
          disabled: baseColors.neutral["500"]
        }
      }
    }
  },
  links: {
    disabled: "#bbb9b7",
    action: {
      default: baseColors.purple["800"],
      hover: baseColors.purple["600"],
      pressed: baseColors.purple["700"]
    },
    destructive: {
      default: baseColors.red["800"],
      hover: baseColors.red["600"],
      pressed: baseColors.red["700"]
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: baseColors.neutral["0"],
      hover: baseColors.neutral["200"],
      pressed: baseColors.neutral["400"],
      selected: baseColors.purple["200"],
      selectedHover: baseColors.purple["400"],
      activated: baseColors.purple["400"],
      disabled: baseColors.neutral["100"]
    },
    border: {
      default: baseColors.neutral["400"],
      hover: baseColors.purple["400"],
      pressed: baseColors.neutral["700"],
      selected: baseColors.purple["600"]
    },
    text: {
      default: baseColors.neutral["900"],
      selected: baseColors.neutral["900"],
      disabled: curriedTransparentize$1(0.3, baseColors.neutral["900"]),
      // 70% opacity of default text color
      hint: curriedTransparentize$1(0.65, baseColors.neutral["900"])
      // 35% opacity of default text color
    }
  },
  iconInteraction: {
    disabled: baseColors.neutral["500"],
    action: {
      default: baseColors.purple["800"],
      hover: baseColors.purple["600"],
      pressed: baseColors.purple["700"]
    },
    onColor: {
      default: "rgba(255, 255, 255)",
      hover: "rgba(255, 255, 255, 0.8)",
      pressed: "rgba(255, 255, 255, 0.9)"
    },
    destructive: {
      default: baseColors.red["800"],
      hover: baseColors.red["600"],
      pressed: baseColors.red["700"]
    }
  },
  chart: {
    line: {
      L1: "#278904",
      L2: "#CC1AD4"
    },
    bar: {
      B1: "#4695D4",
      B2: "#38179E",
      B3: "#4695D4",
      B4: "#278904",
      B5: "#BA1C21"
    },
    area: {
      A1: "#38179E",
      A1Fill: "#5E65FB20"
    },
    pie: {
      P1: "#278904",
      P2: "#38179E",
      P3: "#4695D4"
    }
  }
};
const purpleTokens = extendsType()(merge({}, BASE_TOKENS, {
  colors: {
    ...baseColors,
    ...purpleEnterpriseColors,
    gradients: GRADIENTS
  },
  fonts: {
    fontsToLoad: [FontLoaderFonts.Caveat, FontLoaderFonts.Rotunda]
  }
}));
const backupFonts = 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';
const typographyGroupsOverrides = extendsType()({
  headlineProps: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: purpleTokens.fonts.weights.bold,
    color: purpleTokens.colors.text.headline
  },
  headerProps: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: purpleTokens.fonts.weights.medium,
    letterSpacing: "0em"
  },
  bodyProps: {
    fontWeight: purpleTokens.fonts.weights.light,
    fontFamily: `Rotunda, ${backupFonts}`,
    letterSpacing: "0em",
    lineHeight: purpleTokens.fonts.lineHeights["140%"],
    defaultVariant: "bodyMediumDesktop"
  },
  labelProps: {
    fontFamily: `Rotunda, ${backupFonts}`,
    letterSpacing: purpleTokens.fonts.letterSpacing["12%"],
    lineHeight: purpleTokens.fonts.lineHeights["140%"],
    fontWeight: purpleTokens.fonts.weights.normal,
    textTransform: "uppercase"
  },
  signatureProps: {
    fontFamily: "Caveat"
  },
  numericTextProps: {
    fontFamily: `Rotunda, ${backupFonts}`
  },
  hyperlinkProps: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: purpleTokens.fonts.weights.normal
  },
  disclaimerProps: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: purpleTokens.fonts.weights.light,
    letterSpacing: "0rem"
  }
});
const COLOR_TEXT_HEADLINE = "#0B3541";
const COLOR_TEXT_DEFAULT = "#282624";
const COLOR_TEXT_SUBDUED = "#6E6E6E";
const purpleTypography = merge({}, buildTypographyVariants(typographyGroupsOverrides)(purpleTokens), {
  headline: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: "700",
    color: COLOR_TEXT_HEADLINE,
    letterSpacing: "-0.01em",
    lineHeight: "125%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: "500",
    color: COLOR_TEXT_DEFAULT,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT,
    colorSubdued: COLOR_TEXT_SUBDUED,
    lineHeight: "140%",
    uppercase: true,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: "300",
    color: COLOR_TEXT_DEFAULT,
    colorSubdued: COLOR_TEXT_SUBDUED,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT,
    fontFamily: `Rotunda, ${backupFonts}`,
    fontWeight: "400",
    lineHeight: "160%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  },
  variants: {
    // Bestow purple has some unique line-height styles
    headlineLarge: {
      desktop: {
        lineHeight: "120%"
      },
      mobile: {
        lineHeight: "120%"
      }
    },
    headlineMedium: {
      desktop: {
        lineHeight: "125%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headlineSmall: {
      desktop: {
        lineHeight: "125%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headerXLarge: {
      desktop: {
        lineHeight: "120%"
      },
      mobile: {
        lineHeight: "120%"
      }
    },
    headerLarge: {
      desktop: {
        lineHeight: "120%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headerMedium: {
      desktop: {
        lineHeight: "130%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headerSmall: {
      desktop: {
        lineHeight: "140%"
      },
      mobile: {
        lineHeight: "140%"
      }
    },
    headerXSmall: {
      desktop: {
        lineHeight: "140%"
      },
      mobile: {
        lineHeight: "140%"
      }
    }
  }
});
const purpleComponentStyles = {
  spinners: {
    sizes: {
      small: {
        spinnerSVGGradient: purpleTokens.colors.gradients.svg.g1
      },
      medium: {
        spinnerSVGGradient: purpleTokens.colors.gradients.svg.g1
      },
      large: {
        spinnerSVGGradient: purpleTokens.colors.gradients.svg.g1
      }
    }
  },
  sliderInput: {
    thumbStyle: {
      color: purpleTokens.colors.iconInteraction.action.default
    }
  },
  badges: {
    paddingTop: "4px",
    paddingBottom: "2px",
    borderRadius: "6px",
    sizes: {
      compact: {
        borderRadius: "3px"
      }
    }
  },
  banners: {
    borderRadius: "6px"
  },
  buttons: {
    variants: {},
    sizes: {
      large: {
        padding: "12px 32px 10px"
      },
      medium: {
        padding: "9px 16px 7px"
      },
      small: {
        padding: "5px 12px 3px"
      }
    }
  },
  highlightedCheckbox: {
    background: {
      default: baseColors.purple["50"],
      hover: baseColors.purple["200"],
      disabled: baseColors.neutral["100"],
      invalid: baseColors.red["50"]
    },
    background_image_color: {
      default: baseColors.purple["500"],
      hover: baseColors.purple["700"],
      disabled: baseColors.neutral["500"],
      invalid: baseColors.red["600"]
    },
    outline: {
      focus: baseColors.purple["600"]
    },
    textColor: {
      disabled: purpleTokens.colors.text.subdued
    }
  },
  inputs: {
    borderRadius: "6px",
    allCaps: false
  },
  links: {
    variants: {
      auto: {
        color: purpleTokens.colors.links.action.default,
        fill: purpleTokens.colors.links.action.default,
        hoverStyle: {
          color: purpleTokens.colors.links.action.hover
        },
        activeStyle: {
          color: purpleTokens.colors.links.action.pressed
        }
      }
    }
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/bestow-onLight.svg", "Bestow"),
        logoMark: getStaticAssetUrl("/Logos/bestow-icon-onLight.svg", "Bestow")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/bestow-onDark.svg", "Bestow"),
        logoMark: getStaticAssetUrl("/Logos/bestow-icon-onDark.svg", "Bestow")
      },
      auto: "onLight"
    }
  },
  popovers: {
    variants: {
      tooltip: {
        background: purpleEnterpriseColors.background.brand
      }
    }
  },
  signature: {
    background: {
      default: baseColors.purple["50"],
      hover: baseColors.purple["200"],
      disabled: baseColors.neutral["100"]
    },
    borderColor: {
      default: baseColors.purple["500"],
      hover: baseColors.purple["700"],
      disabled: "#BBBBBB"
    },
    textColor: {
      disabled: "#6e6b68"
    }
  }
};
const PURPLE_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(purpleTokens, purpleTypography),
  // The "as const" here allows TS to view this type as "Purple Theme" instead of just "string"
  name: "Purple Theme",
  key: "PURPLE_THEME"
}, purpleComponentStyles));
export {
  checkButtonThemeFormat as A,
  BASE_STATIC_BUCKET_MAP as B,
  linksForTheme as C,
  FontLoaderFonts as F,
  PURPLE_THEME as P,
  _inheritsLoose$1 as _,
  BASE_TOKENS as a,
  buildBaseTheme as b,
  checkThemeContract as c,
  curriedTransparentize$1 as d,
  extendsType as e,
  BASE_FONTS as f,
  getStaticAssetUrl as g,
  buildTypographyVariants as h,
  BASE_COLOR_SCALES as i,
  assign as j,
  getDefaultExportFromCjs as k,
  PropTypes as l,
  merge as m,
  _extends$1 as n,
  _assertThisInitialized as o,
  get$1 as p,
  commonjsGlobal as q,
  omit$1 as r,
  propTypesExports as s,
  getAugmentedNamespace as t,
  isEqual2 as u,
  _setPrototypeOf as v,
  _isNativeReflectConstruct as w,
  _getPrototypeOf as x,
  FONT_FILE_MAPPINGS as y,
  FontLoader as z
};
